
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("26nI6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6ee964aae9c29359$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $b7Gp9 = parcelRequire("b7Gp9");

var $dXq4S = parcelRequire("dXq4S");

var $dAfqg = parcelRequire("dAfqg");

var $DVljb = parcelRequire("DVljb");

var $9OXo1 = parcelRequire("9OXo1");

var $4HJKb = parcelRequire("4HJKb");
const $6ee964aae9c29359$var$DevDetailsDialogLoader = (props)=>{
    const { onCloseDevDetailDialog: onCloseDevDetailDialog, state: state, actions: actions } = props;
    const hookedLocale = (0, $DVljb.useLocale)();
    const { issueId: issueId, issueKey: issueKey, locale: locale, dataTypeSelected: dataTypeSelected, isDevPanelDetailsDialogShown: isDevPanelDetailsDialogShown, legacyDevPanelDetailsDialogShownCounter: legacyDevPanelDetailsDialogShownCounter, legacyData: legacyData } = state ?? {};
    const { closeDetailDialog: closeDetailDialog, updateState: updateStateAction } = actions ?? {};
    const onClose = ()=>{
        onCloseDevDetailDialog();
        closeDetailDialog();
    };
    const dialogBridge = (0, $5uXOq.useRef)(null);
    const currentLegacyDevPanelDetailsDialogShownCounter = (0, $5uXOq.useRef)(legacyDevPanelDetailsDialogShownCounter);
    (0, $5uXOq.useEffect)(()=>{
        const updatedState = {
            locale: hookedLocale
        };
        updateStateAction(updatedState);
    }, [
        hookedLocale,
        updateStateAction
    ]);
    (0, $5uXOq.useEffect)(()=>{
        /** Valid cases
		 *  When dialog is open
		 *  AND
		 *  issueId is a non empty string
		 *  AND
		 *  issueKey is a string
		 */ const isShowingDialog = isDevPanelDetailsDialogShown || currentLegacyDevPanelDetailsDialogShownCounter.current !== legacyDevPanelDetailsDialogShownCounter;
        const hasValidIssueId = typeof issueId === 'string' && issueId !== '';
        if (isShowingDialog && !hasValidIssueId) throw new Error('Could not find a valid "issueId" value.');
    }, [
        isDevPanelDetailsDialogShown,
        issueId,
        issueKey,
        legacyDevPanelDetailsDialogShownCounter,
        updateStateAction
    ]);
    (0, $5uXOq.useEffect)(()=>{
        async function waitforBridge() {
            await (0, $4HJKb.loadDialogBridge)().then((bridge)=>{
                dialogBridge.current = bridge;
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                dialogBridge.current.showDialog(issueKey ?? '', issueId ?? '', legacyData, dataTypeSelected, false);
            }).catch((exception)=>{
                throw exception;
            });
        }
        if (currentLegacyDevPanelDetailsDialogShownCounter.current !== legacyDevPanelDetailsDialogShownCounter) {
            currentLegacyDevPanelDetailsDialogShownCounter.current = legacyDevPanelDetailsDialogShownCounter;
            if (dialogBridge.current) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            dialogBridge.current.showDialog(issueKey ?? '', issueId ?? '', legacyData, dataTypeSelected, false);
            else waitforBridge();
        }
    }, [
        legacyData,
        dataTypeSelected,
        dialogBridge,
        issueId,
        issueKey,
        legacyDevPanelDetailsDialogShownCounter
    ]);
    const projectContext = (0, $dAfqg.useProjectContext)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const projectAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        resourceType: 'project',
        cloudId: tenantContext.cloudId,
        resourceId: projectContext.data?.projectId?.toString() ?? ''
    });
    return isDevPanelDetailsDialogShown ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b7Gp9.default), {
        issueId: issueId ?? '',
        issueKey: issueKey ?? '',
        baseUrl: "",
        // @ts-expect-error - TS2322 - Type 'Locale | undefined' is not assignable to type 'Locale'.
        locale: locale,
        // @ts-expect-error - TS2322 - Type 'PanelDataTypes | undefined' is not assignable to type 'PanelDataTypes'.
        selectedTab: dataTypeSelected,
        showRemoteLinks: true,
        onCloseDialog: onClose,
        projectAri: projectAri || '',
        accountId: tenantContext.atlassianAccountId || ''
    }) : null;
};
$6ee964aae9c29359$var$DevDetailsDialogLoader.defaultProps = {
    onCloseDevDetailDialog: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    scopeId: ''
};
const $6ee964aae9c29359$var$DevDetailDialogLoaderWithContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4HJKb.DevOpsDetailsDialogLoaderContainer), {
        scope: props.scopeId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4HJKb.DevOpsDetailsDialogLoaderSubscriber), null, (state, actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ee964aae9c29359$var$DevDetailsDialogLoader, {
            state: state,
            actions: actions
        })));
$6ee964aae9c29359$var$DevDetailDialogLoaderWithContainer.defaultProps = {
    onCloseDevDetailDialog: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $6ee964aae9c29359$export$2e2bcd8739ae039 = $6ee964aae9c29359$var$DevDetailDialogLoaderWithContainer;

});
parcelRegister("b7Gp9", function(module, exports) {

$parcel$export(module.exports, "default", () => $53328186cfad8502$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DevelopmentDetailsDialogEntryPoint", () => $53328186cfad8502$export$4197863464fe025c);

var $5uXOq = parcelRequire("5uXOq");

var $jD5no = parcelRequire("jD5no");

var $9pe79 = parcelRequire("9pe79");

var $iUFzA = parcelRequire("iUFzA");

var $7iJwP = parcelRequire("7iJwP");

var $iuYCn = parcelRequire("iuYCn");

var $ewhuS = parcelRequire("ewhuS");

var $7qcff = parcelRequire("7qcff");

var $3Q7M9 = parcelRequire("3Q7M9");

var $cguAt = parcelRequire("cguAt");
class $53328186cfad8502$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.store = (0, $3Q7M9.default)((0, $ewhuS.default));
        this.dispatchProps();
    }
    componentDidUpdate(prevProps) {
        const { onCloseDialog: _, ...prevPropsWithoutFunc } = prevProps;
        const { onCloseDialog: __, ...currentPropsWithoutFunc } = this.props;
        if ((0, $9pe79.default)(prevPropsWithoutFunc, currentPropsWithoutFunc)) return;
        this.dispatchProps();
    }
    dispatchProps() {
        const { onCloseDialog: onCloseDialog, ...stateProps } = this.props;
        this.store.dispatch((0, $7qcff.initializeAppProps)(stateProps));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            id: "developmentDetailsDialog",
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
            id: "developmentDetailsDialog",
            packageName: "jiraDevelopmentDetails"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iUFzA.StartMetric), {
            metric: (0, $iuYCn.devDetailsTimeToLoad)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cguAt.default), this.props)));
    }
}
const $53328186cfad8502$export$4197863464fe025c = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($53328186cfad8502$export$2e2bcd8739ae039, props);

});
parcelRegister("iUFzA", function(module, exports) {

$parcel$export(module.exports, "StopMetric", () => $a40e3e786c0f21ac$export$e96ff7553eadd2a8);
$parcel$export(module.exports, "StartMetric", () => $a40e3e786c0f21ac$export$a8cf8910f40934b2);
$parcel$export(module.exports, "CancelMetric", () => $a40e3e786c0f21ac$export$a5e1c0987a3361a0);

var $5uXOq = parcelRequire("5uXOq");
const $a40e3e786c0f21ac$export$e96ff7553eadd2a8 = ({ metric: metric })=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        metric.stop();
    }, [
        metric
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $a40e3e786c0f21ac$export$a8cf8910f40934b2 = ({ metric: metric })=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        metric.start();
    }, [
        metric
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $a40e3e786c0f21ac$export$a5e1c0987a3361a0 = ({ metric: metric })=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        metric.cancel();
    }, [
        metric
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};

});

parcelRegister("iuYCn", function(module, exports) {

$parcel$export(module.exports, "devDetailsTimeToLoad", () => $d91f1132d0889966$export$f880e4362c4a6a42);

var $dGrdR = parcelRequire("dGrdR");
const $d91f1132d0889966$export$f880e4362c4a6a42 = (0, $dGrdR.metrics).interaction({
    key: 'dev-details.time-to.load',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '300_1000_2500_4000_7000_10000'
    }
});

});

parcelRegister("ewhuS", function(module, exports) {

$parcel$export(module.exports, "default", () => $677ac1e44ab12c15$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $kleDs = parcelRequire("kleDs");


var $c66QQ = parcelRequire("c66QQ");

var $jP4SE = parcelRequire("jP4SE");

var $hg7ZY = parcelRequire("hg7ZY");

var $aXVqb = parcelRequire("aXVqb");

var $9P9CS = parcelRequire("9P9CS");
const $677ac1e44ab12c15$var$epic = (0, $e1AU2.combineEpics)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(0, $9P9CS.epic), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(0, $hg7ZY.epic), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(0, $aXVqb.epic), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(0, $aXVqb.optOutDeploymentDetailDiscovery), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(0, $c66QQ.epic), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(0, $jP4SE.epic));
var $677ac1e44ab12c15$export$2e2bcd8739ae039 = (0, $kleDs.default)((0, $ed461637e46aec23$export$d76071d5de2774fc), 'root', $677ac1e44ab12c15$var$epic);

});
parcelRegister("kleDs", function(module, exports) {

$parcel$export(module.exports, "default", () => $80cd67c932e51ded$export$2e2bcd8739ae039);
parcelRequire("c66Ur");

var $2YZCu = parcelRequire("2YZCu");

var $aMh57 = parcelRequire("aMh57");
var /*
 * Catches errors within the epic middleware and makes them available to monitoring.
 *
 * Takes an optional handler as a parameter that can be executed when an error is encountered.
 * This handler returns an observable.
 * This could be used to show an error flag, for example, but will replace attempting to continue
 * the current observable stream.
 *
 * Example usage, which could be applied to the root epic:
 * errorHandlerEpicMiddleware('your-app-name', 'root', combineEpics(epicOne, epicTwo));
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$80cd67c932e51ded$export$2e2bcd8739ae039 = (appId, location, epic, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorHandler)=>(action$, store, deps)=>epic(action$, store, deps).catch((error, stream)=>{
            const fullLocation = `common.epic-error.${appId}.${location}`;
            (0, $2YZCu.default).safeErrorWithoutCustomerData(fullLocation, 'Unhandled error in epic', error);
            (0, $aMh57.captureException)(fullLocation, error);
            return errorHandler && errorHandler(error) || stream;
        });

});

const $ed461637e46aec23$export$d76071d5de2774fc = 'development.details';
const $ed461637e46aec23$export$2fda0856fe66a3c9 = 'DECLINED';
const $ed461637e46aec23$export$bb29a81b503a982c = 'OPEN';
const $ed461637e46aec23$export$26d1e2e6f089e8e4 = 'MERGED';
const $ed461637e46aec23$export$45cb93f72f62540e = 'UNKNOWN';
const $ed461637e46aec23$export$22401eb1dff04df = 'DRAFT';
const $ed461637e46aec23$export$dc9cab921059a72 = 'ADDED';
const $ed461637e46aec23$export$ab06cbdc503432af = 'COPIED';
const $ed461637e46aec23$export$1cc76b53f23597de = 'DELETED';
const $ed461637e46aec23$export$57804c30bf47412d = 'MODIFIED';
const $ed461637e46aec23$export$fdd9e4df1aa8958d = 'MOVED';
const $ed461637e46aec23$export$d71930f7f5807a72 = 'FAILED';
const $ed461637e46aec23$export$42dd0cdd351a4a9 = 'PRODUCTION';
const $ed461637e46aec23$export$a739cd5aac835909 = 'STAGING';
const $ed461637e46aec23$export$5d789bb7ceeee381 = 'TESTING';
const $ed461637e46aec23$export$23da285852fc57fc = 'DEVELOPMENT';
const $ed461637e46aec23$export$a404d8a18351cf3e = 'UNMAPPED';
const $ed461637e46aec23$export$78244dbb77cfa6b6 = 'UNKNOWN';
const $ed461637e46aec23$export$aebb42912407fb2d = 'PENDING';
const $ed461637e46aec23$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $ed461637e46aec23$export$6b4658081fcf1aed = 'CANCELLED';
const $ed461637e46aec23$export$4de3c8d09c338516 = 'FAILED';
const $ed461637e46aec23$export$23bb00587dc6c61 = 'ROLLED_BACK';
const $ed461637e46aec23$export$f7d0ae1e964896fb = 'SUCCESSFUL';
const $ed461637e46aec23$export$e68cad5334cc5b = 'vyhOd8hgbSa4rzgnTvyaZNSUqUViKIOc';
const $ed461637e46aec23$export$a42a1a2fb6310bc7 = 'oAPCjkrphiFxmqbTLkv9r2jBFTvfOI8x';

parcelRegister("c66QQ", function(module, exports) {

$parcel$export(module.exports, "epic", () => $0f9f6ffa0e82fcaf$export$8ec5145af6f76965);
parcelRequire("d0pqD");
parcelRequire("1oQta");
parcelRequire("64ZAE");
parcelRequire("hZWgu");

var $g9E9n = parcelRequire("g9E9n");

var $iiQPz = parcelRequire("iiQPz");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0f9f6ffa0e82fcaf$var$getAnalyticsForAction = (state, action)=>(0, $iiQPz.default)[action.type] && (0, $iiQPz.default)[action.type](state, action);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0f9f6ffa0e82fcaf$var$triggerAnalyticsForAction = (event)=>{
    (0, $g9E9n.getAnalyticsWebClient)().sendEvent(event);
};
const $0f9f6ffa0e82fcaf$export$8ec5145af6f76965 = (action$, store)=>action$.map((action)=>$0f9f6ffa0e82fcaf$var$getAnalyticsForAction(store.getState(), action)).filter((event)=>!!event).do($0f9f6ffa0e82fcaf$var$triggerAnalyticsForAction).ignoreElements();

});
parcelRegister("iiQPz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d98248c73fa782c$export$2e2bcd8739ae039);


var $kw5c5 = parcelRequire("kw5c5");

var $fydSM = parcelRequire("fydSM");

var $dmU03 = parcelRequire("dmU03");

var $CSK1u = parcelRequire("CSK1u");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$6d98248c73fa782c$export$2e2bcd8739ae039 = {
    [(0, $kw5c5.FIRE_DETAIL_DATA_FETCHED_EVENT)]: (state)=>({
            payload: {
                action: 'fetched',
                actionSubject: 'devDetails',
                attributes: (0, $fydSM.getDetailsReceivedEventAttributes)(state),
                source: (0, $CSK1u.getActiveTab)(state)
            },
            type: (0, $4d5e0871c06cee03$export$947dac6c72b26f81)
        }),
    [(0, $kw5c5.FIRE_BITBUCKET_DIFFSTAT_ANALYTICS_EVENT)]: (state)=>({
            payload: {
                action: (0, $dmU03.hasEmptyDiffstatForBitbucket)(state) ? 'partiallyFetched' : 'fullyFetched',
                actionSubject: 'bitbucketDiffstat',
                source: (0, $CSK1u.getActiveTab)(state)
            },
            type: (0, $4d5e0871c06cee03$export$947dac6c72b26f81)
        })
};

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("kw5c5", function(module, exports) {

$parcel$export(module.exports, "FETCH_DETAIL", () => $78fd28ef540e2d6c$export$7c81183ccbd666a0);
$parcel$export(module.exports, "fetchDetail", () => $78fd28ef540e2d6c$export$47d408f9b5e5593);
$parcel$export(module.exports, "SET_DETAIL_DATA", () => $78fd28ef540e2d6c$export$58da932e063231b2);
$parcel$export(module.exports, "FIRE_BITBUCKET_DIFFSTAT_ANALYTICS_EVENT", () => $78fd28ef540e2d6c$export$af2bad8228f8ff6b);
$parcel$export(module.exports, "FIRE_DETAIL_DATA_FETCHED_EVENT", () => $78fd28ef540e2d6c$export$dd96e80386f99333);
$parcel$export(module.exports, "setDetailData", () => $78fd28ef540e2d6c$export$18e0d0155f246019);
$parcel$export(module.exports, "fireBitbucketDiffstatAnalyticsEvent", () => $78fd28ef540e2d6c$export$5cf89552779ba9cc);
$parcel$export(module.exports, "fireDetailDataFetchedEvent", () => $78fd28ef540e2d6c$export$cd584a07ce04110f);
$parcel$export(module.exports, "FETCHING_FAILED", () => $78fd28ef540e2d6c$export$ea08e92921a33ed2);
$parcel$export(module.exports, "fetchingFailed", () => $78fd28ef540e2d6c$export$89102398fbdad13e);
$parcel$export(module.exports, "OPT_OUT_DEPLOYMENTS_DISCOVERY", () => $78fd28ef540e2d6c$export$8626d637eb2f308f);
$parcel$export(module.exports, "optOutDeploymentDetailDiscovery", () => $78fd28ef540e2d6c$export$749833718123995b);
const $78fd28ef540e2d6c$export$7c81183ccbd666a0 = 'state.actions.details.FETCH_DETAIL';
const $78fd28ef540e2d6c$export$47d408f9b5e5593 = ()=>({
        type: $78fd28ef540e2d6c$export$7c81183ccbd666a0
    });
const $78fd28ef540e2d6c$export$58da932e063231b2 = 'state.actions.details.SET_DETAIL_DATA';
const $78fd28ef540e2d6c$export$af2bad8228f8ff6b = 'state.actions.details.FIRE_BITBUCKET_DIFFSTAT_ANALYTICS_EVENT';
const $78fd28ef540e2d6c$export$dd96e80386f99333 = 'state.actions.details.FIRE_DETAIL_DATA_FETCHED_EVENT';
const $78fd28ef540e2d6c$export$18e0d0155f246019 = (payload)=>({
        type: $78fd28ef540e2d6c$export$58da932e063231b2,
        payload: payload
    });
const $78fd28ef540e2d6c$export$5cf89552779ba9cc = ()=>({
        type: $78fd28ef540e2d6c$export$af2bad8228f8ff6b
    });
const $78fd28ef540e2d6c$export$cd584a07ce04110f = (payload)=>({
        type: $78fd28ef540e2d6c$export$dd96e80386f99333,
        payload: payload
    });
const $78fd28ef540e2d6c$export$ea08e92921a33ed2 = 'state.actions.details.FETCHING_FAILED';
const $78fd28ef540e2d6c$export$89102398fbdad13e = ()=>({
        type: $78fd28ef540e2d6c$export$ea08e92921a33ed2
    });
const $78fd28ef540e2d6c$export$8626d637eb2f308f = 'state.actions.OPT_OUT_DEPLOYMENTS_DISCOVERY';
const $78fd28ef540e2d6c$export$749833718123995b = ()=>({
        type: $78fd28ef540e2d6c$export$8626d637eb2f308f
    });

});

parcelRegister("fydSM", function(module, exports) {

$parcel$export(module.exports, "getDetailsReceivedEventAttributes", () => $90cd73e63cd2c6b3$export$458dd654ee9bc830);

var $dGvGJ = parcelRequire("dGvGJ");

var $i9ldv = parcelRequire("i9ldv");

var $jaBqM = parcelRequire("jaBqM");

var $dmU03 = parcelRequire("dmU03");

var $3AV3y = parcelRequire("3AV3y");

var $77bcb = parcelRequire("77bcb");

var $g1a7N = parcelRequire("g1a7N");

var $6j0Io = parcelRequire("6j0Io");
const $90cd73e63cd2c6b3$export$458dd654ee9bc830 = (0, $dGvGJ.createSelector)([
    (0, $77bcb.getAllInstanceTypeDetails),
    (0, $dmU03.getAllRepositories),
    (0, $dmU03.getAllCommitsCount),
    (0, $i9ldv.getAllBranches),
    (0, $g1a7N.getAllPullRequests),
    (0, $jaBqM.getBuildProviders),
    (0, $jaBqM.getBuildsCount),
    (0, $3AV3y.getDeploymentsCount),
    (0, $6j0Io.getRemoteLinksTotalCount)
], (instanceTypes, repositories, commitsCount, branches, pullrequests, buildProviders, buildsCount, deploymentsCount, remoteLinksCount)=>({
        instanceTypeCount: instanceTypes.length,
        buildProvidersCount: buildProviders.length,
        reposCount: repositories.length,
        commitsCount: commitsCount,
        branchesCount: branches.length,
        pullrequestsCount: pullrequests.length,
        buildsCount: buildsCount,
        deploymentsCount: deploymentsCount,
        remoteLinksCount: remoteLinksCount
    }));

});
parcelRegister("i9ldv", function(module, exports) {

$parcel$export(module.exports, "getAllBranches", () => $85a3cc0454bd5847$export$fbe7833bb0d7195a);
$parcel$export(module.exports, "getMultiInstanceBranchForId", () => $85a3cc0454bd5847$export$87498f3bd3494113);
$parcel$export(module.exports, "multiInstanceHasBranches", () => $85a3cc0454bd5847$export$784f5a944dddf872);
$parcel$export(module.exports, "getDiscoveryBranchesWithoutPRs", () => $85a3cc0454bd5847$export$e739fc2a0d32424b);

var $dGvGJ = parcelRequire("dGvGJ");

var $183uB = parcelRequire("183uB");

var $hN6Bx = parcelRequire("hN6Bx");

var $rwCaG = parcelRequire("rwCaG");

var $ejRbr = parcelRequire("ejRbr");

var $4Xk2W = parcelRequire("4Xk2W");

var $77bcb = parcelRequire("77bcb");
const $85a3cc0454bd5847$var$mapInstanceTypeDetailsToBranchesList = (instanceTypeDetails)=>instanceTypeDetails ? (0, (/*@__PURE__*/$parcel$interopDefault($183uB)))(instanceTypeDetails.map((instanceTypeDetail)=>(0, (/*@__PURE__*/$parcel$interopDefault($183uB)))(instanceTypeDetail.repositories.map((repo)=>repo.branches)))) : [];
const $85a3cc0454bd5847$export$8e83e642f64b3797 = (0, $dGvGJ.createSelector)([
    (0, $77bcb.getSelectedInstanceTypeDetails)
], $85a3cc0454bd5847$var$mapInstanceTypeDetailsToBranchesList);
const $85a3cc0454bd5847$export$fbe7833bb0d7195a = (0, $dGvGJ.createSelector)([
    (0, $77bcb.getAllInstanceTypeDetails)
], $85a3cc0454bd5847$var$mapInstanceTypeDetailsToBranchesList);
const $85a3cc0454bd5847$var$getBranchById = (0, $dGvGJ.createSelector)([
    $85a3cc0454bd5847$export$8e83e642f64b3797
], (branches)=>(0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(branches, (branch)=>branch.id));
const $85a3cc0454bd5847$var$getMultiInstanceBranchById = (0, $dGvGJ.createSelector)([
    $85a3cc0454bd5847$export$fbe7833bb0d7195a
], (branches)=>(0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(branches, (branch)=>branch.id));
const $85a3cc0454bd5847$export$8d582806d4ccfa1 = (state, id)=>$85a3cc0454bd5847$var$getBranchById(state)[id];
const $85a3cc0454bd5847$export$87498f3bd3494113 = (state, id)=>$85a3cc0454bd5847$var$getMultiInstanceBranchById(state)[id];
const $85a3cc0454bd5847$export$7dc8fa28986f6e8a = (state)=>$85a3cc0454bd5847$export$8e83e642f64b3797(state).length > 0;
const $85a3cc0454bd5847$export$784f5a944dddf872 = (state)=>$85a3cc0454bd5847$export$fbe7833bb0d7195a(state).length > 0;
const $85a3cc0454bd5847$var$flattenEligibleBranches = (0, (/*@__PURE__*/$parcel$interopDefault($ejRbr)))((0, (/*@__PURE__*/$parcel$interopDefault($hN6Bx)))((0, (/*@__PURE__*/$parcel$interopDefault($rwCaG)))([], 'repositories')), (0, (/*@__PURE__*/$parcel$interopDefault($hN6Bx)))((0, (/*@__PURE__*/$parcel$interopDefault($rwCaG)))([], 'branches')));
const $85a3cc0454bd5847$export$e739fc2a0d32424b = (0, $dGvGJ.createSelector)([
    (0, $77bcb.getInstancesForPRDiscovery)
], $85a3cc0454bd5847$var$flattenEligibleBranches);

});
parcelRegister("hN6Bx", function(module, exports) {

var $lVx1a = parcelRequire("lVx1a");

var $cf3c22c975221822$var$func = $lVx1a('flatMapDeep', (parcelRequire("5yUQz")));

$cf3c22c975221822$var$func.placeholder = (parcelRequire("aPsMW"));
module.exports = $cf3c22c975221822$var$func;

});
parcelRegister("5yUQz", function(module, exports) {

var $ekcP3 = parcelRequire("ekcP3");

var $80afZ = parcelRequire("80afZ");
/** Used as references for various `Number` constants. */ var $40cc395748a0fa81$var$INFINITY = 1 / 0;
/**
 * This method is like `_.flatMap` except that it recursively flattens the
 * mapped results.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [[[n, n]]];
 * }
 *
 * _.flatMapDeep([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $40cc395748a0fa81$var$flatMapDeep(collection, iteratee) {
    return $ekcP3($80afZ(collection, iteratee), $40cc395748a0fa81$var$INFINITY);
}
module.exports = $40cc395748a0fa81$var$flatMapDeep;

});


parcelRegister("rwCaG", function(module, exports) {

var $lVx1a = parcelRequire("lVx1a");

var $052bd25305b70111$var$func = $lVx1a('getOr', (parcelRequire("9XE6b")));

$052bd25305b70111$var$func.placeholder = (parcelRequire("aPsMW"));
module.exports = $052bd25305b70111$var$func;

});

parcelRegister("ejRbr", function(module, exports) {

module.exports = (parcelRequire("g1VnK"));

});
parcelRegister("g1VnK", function(module, exports) {

var $lVx1a = parcelRequire("lVx1a");

var $bab9403b96f3051c$var$func = $lVx1a('flow', (parcelRequire("basmW")));

$bab9403b96f3051c$var$func.placeholder = (parcelRequire("aPsMW"));
module.exports = $bab9403b96f3051c$var$func;

});


parcelRegister("77bcb", function(module, exports) {

$parcel$export(module.exports, "getDetailsState", () => $5c222c3ed2da0549$export$36374ff7f1c7f085);
$parcel$export(module.exports, "getSelectedInstanceTypeDetails", () => $5c222c3ed2da0549$export$90d81d836943c1f4);
$parcel$export(module.exports, "getSelectedInstanceBaseUrl", () => $5c222c3ed2da0549$export$f25909d41e7c3596);
$parcel$export(module.exports, "getAllInstanceTypeDetails", () => $5c222c3ed2da0549$export$f7d180cb9209dcec);
$parcel$export(module.exports, "getInstanceTypeDetailsByType", () => $5c222c3ed2da0549$export$4bd371ac17f17b0c);
$parcel$export(module.exports, "getEmbeddedMarketplaceDetails", () => $5c222c3ed2da0549$export$e9bd43294bf74a3f);
$parcel$export(module.exports, "getMultiInstanceRepositories", () => $5c222c3ed2da0549$export$1b565ead0501711b);
$parcel$export(module.exports, "getInstancesForPRDiscovery", () => $5c222c3ed2da0549$export$4ae1ca4d8dfd8e92);
$parcel$export(module.exports, "getAllErrorLinks", () => $5c222c3ed2da0549$export$1455390c38defce);
$parcel$export(module.exports, "getErrorLink", () => $5c222c3ed2da0549$export$9929a1adbfb16fc0);
$parcel$export(module.exports, "getUnauthorizedApplink", () => $5c222c3ed2da0549$export$1b44a95dd4eb1159);
$parcel$export(module.exports, "getAllUnauthorizedApplinks", () => $5c222c3ed2da0549$export$e8ae11b2ac9c5de0);
$parcel$export(module.exports, "isApplicationError", () => $5c222c3ed2da0549$export$8bc44987d4666606);
$parcel$export(module.exports, "isLoading", () => $5c222c3ed2da0549$export$20bb0d907fbbe433);
$parcel$export(module.exports, "isError", () => $5c222c3ed2da0549$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isDiffstatAnalyticsFired", () => $5c222c3ed2da0549$export$60ddc2fc18c04001);
$parcel$export(module.exports, "isOptOutOfDeploymentDiscovery", () => $5c222c3ed2da0549$export$c2756dd1269e3ee2);

var $dGvGJ = parcelRequire("dGvGJ");

var $183uB = parcelRequire("183uB");

var $1a66N = parcelRequire("1a66N");

var $kxJGV = parcelRequire("kxJGV");

var $ejRbr = parcelRequire("ejRbr");

var $4Xk2W = parcelRequire("4Xk2W");

var $CSK1u = parcelRequire("CSK1u");
const $5c222c3ed2da0549$export$36374ff7f1c7f085 = (state)=>state.details;
const $5c222c3ed2da0549$export$90d81d836943c1f4 = (0, $dGvGJ.createSelector)([
    $5c222c3ed2da0549$export$36374ff7f1c7f085,
    (0, $CSK1u.getSelectedApplicationType)
], (detailsState, selectedType)=>detailsState.details.instanceTypeDetails.filter((item)=>item.type === selectedType));
const $5c222c3ed2da0549$export$f25909d41e7c3596 = (0, $dGvGJ.createSelector)([
    $5c222c3ed2da0549$export$36374ff7f1c7f085,
    (0, $CSK1u.getSelectedApplicationType)
], (detailsState, selectedType)=>detailsState.details.instanceTypeDetails.filter((item)=>item.type === selectedType)[0]?.baseUrl);
const $5c222c3ed2da0549$export$f7d180cb9209dcec = (0, $dGvGJ.createSelector)([
    $5c222c3ed2da0549$export$36374ff7f1c7f085
], (detailsState)=>detailsState.details.instanceTypeDetails);
const $5c222c3ed2da0549$export$4bd371ac17f17b0c = (0, $dGvGJ.createSelector)([
    $5c222c3ed2da0549$export$f7d180cb9209dcec
], (details)=>(0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(details, (detail)=>detail.id));
const $5c222c3ed2da0549$export$e9bd43294bf74a3f = (0, $dGvGJ.createSelector)([
    $5c222c3ed2da0549$export$36374ff7f1c7f085
], (detailsState)=>detailsState.details.embeddedMarketplaceDetails);
const $5c222c3ed2da0549$export$f594c030cdaac8cb = (state)=>{
    const instanceTypeDetails = $5c222c3ed2da0549$export$90d81d836943c1f4(state);
    return instanceTypeDetails ? (0, (/*@__PURE__*/$parcel$interopDefault($183uB)))(instanceTypeDetails.map((instanceType)=>instanceType.repositories)) : [];
};
const $5c222c3ed2da0549$export$1b565ead0501711b = (state)=>{
    const instanceTypeDetails = $5c222c3ed2da0549$export$f7d180cb9209dcec(state);
    return instanceTypeDetails ? (0, (/*@__PURE__*/$parcel$interopDefault($183uB)))(instanceTypeDetails.map((instanceType)=>instanceType.repositories)) : [];
};
const $5c222c3ed2da0549$var$filterBranchesWithoutPRLinks = (0, (/*@__PURE__*/$parcel$interopDefault($1a66N)))((branch)=>!!branch.createPullRequestUrl && branch.pullRequests.length === 0);
const $5c222c3ed2da0549$var$filterRepositoriesWithoutBranchesWithPRLinks = (0, (/*@__PURE__*/$parcel$interopDefault($ejRbr)))((0, (/*@__PURE__*/$parcel$interopDefault($kxJGV)))((repository)=>({
        ...repository,
        branches: $5c222c3ed2da0549$var$filterBranchesWithoutPRLinks(repository.branches)
    })), (0, (/*@__PURE__*/$parcel$interopDefault($1a66N)))((repository)=>repository.branches.length > 0));
const $5c222c3ed2da0549$var$filterInstancesWithoutRepositories = (0, (/*@__PURE__*/$parcel$interopDefault($ejRbr)))((0, (/*@__PURE__*/$parcel$interopDefault($kxJGV)))((instance)=>({
        ...instance,
        repositories: $5c222c3ed2da0549$var$filterRepositoriesWithoutBranchesWithPRLinks(instance.repositories)
    })), (0, (/*@__PURE__*/$parcel$interopDefault($1a66N)))((instance)=>instance.repositories.length > 0));
const $5c222c3ed2da0549$export$4ae1ca4d8dfd8e92 = (0, $dGvGJ.createSelector)($5c222c3ed2da0549$export$f7d180cb9209dcec, $5c222c3ed2da0549$var$filterInstancesWithoutRepositories);
const $5c222c3ed2da0549$var$getErrorLinkForTypes = (instanceTypeDetails)=>{
    const results = [];
    if (instanceTypeDetails.length > 0) instanceTypeDetails.forEach((instanceType)=>{
        if (instanceType.errorLink) results.push(instanceType.errorLink);
    });
    return results;
};
const $5c222c3ed2da0549$var$getUnauthoroizedAppLinks = (instanceTypeDetails)=>{
    const results = [];
    if (instanceTypeDetails.length > 0) instanceTypeDetails.forEach((instanceType)=>{
        if (instanceType.unauthorizedLink) results.push(instanceType.unauthorizedLink);
    });
    return results;
};
const $5c222c3ed2da0549$export$1455390c38defce = (0, $dGvGJ.createSelector)([
    $5c222c3ed2da0549$export$f7d180cb9209dcec
], (instanceTypes)=>$5c222c3ed2da0549$var$getErrorLinkForTypes(instanceTypes));
const $5c222c3ed2da0549$export$9929a1adbfb16fc0 = (0, $dGvGJ.createSelector)([
    $5c222c3ed2da0549$export$90d81d836943c1f4
], (instanceTypes)=>$5c222c3ed2da0549$var$getErrorLinkForTypes(instanceTypes));
const $5c222c3ed2da0549$export$1b44a95dd4eb1159 = (0, $dGvGJ.createSelector)($5c222c3ed2da0549$export$90d81d836943c1f4, (instanceTypes)=>$5c222c3ed2da0549$var$getUnauthoroizedAppLinks(instanceTypes));
const $5c222c3ed2da0549$export$e8ae11b2ac9c5de0 = (0, $dGvGJ.createSelector)($5c222c3ed2da0549$export$f7d180cb9209dcec, (instanceTypes)=>$5c222c3ed2da0549$var$getUnauthoroizedAppLinks(instanceTypes));
const $5c222c3ed2da0549$export$8bc44987d4666606 = (0, $dGvGJ.createSelector)([
    $5c222c3ed2da0549$export$9929a1adbfb16fc0,
    $5c222c3ed2da0549$export$1b44a95dd4eb1159
], (errors, appErrors)=>errors && errors.length > 0 || appErrors && appErrors.length > 0);
const $5c222c3ed2da0549$export$20bb0d907fbbe433 = (state)=>$5c222c3ed2da0549$export$36374ff7f1c7f085(state).isLoading;
const $5c222c3ed2da0549$export$e6127cc7fe7395c3 = (state)=>$5c222c3ed2da0549$export$36374ff7f1c7f085(state).isError;
const $5c222c3ed2da0549$export$60ddc2fc18c04001 = (state)=>$5c222c3ed2da0549$export$36374ff7f1c7f085(state).isDiffstatAnalyticsFired || false;
const $5c222c3ed2da0549$export$c2756dd1269e3ee2 = (state)=>$5c222c3ed2da0549$export$36374ff7f1c7f085(state).isOptOutOfDeploymentDiscovery;

});
parcelRegister("1a66N", function(module, exports) {

var $lVx1a = parcelRequire("lVx1a");

var $0d8b76a3562cac9f$var$func = $lVx1a('filter', (parcelRequire("kPH5D")));

$0d8b76a3562cac9f$var$func.placeholder = (parcelRequire("aPsMW"));
module.exports = $0d8b76a3562cac9f$var$func;

});
parcelRegister("kPH5D", function(module, exports) {

var $2GdQn = parcelRequire("2GdQn");

var $8BRGu = parcelRequire("8BRGu");

var $bxDef = parcelRequire("bxDef");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $f2a9fed894a6616c$var$filter(collection, predicate) {
    var func = $8LQ84(collection) ? $2GdQn : $8BRGu;
    return func(collection, $bxDef(predicate, 3));
}
module.exports = $f2a9fed894a6616c$var$filter;

});
parcelRegister("8BRGu", function(module, exports) {

var $e7pfQ = parcelRequire("e7pfQ");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $644b6c0ae483a6c5$var$baseFilter(collection, predicate) {
    var result = [];
    $e7pfQ(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $644b6c0ae483a6c5$var$baseFilter;

});



parcelRegister("kxJGV", function(module, exports) {

var $lVx1a = parcelRequire("lVx1a");

var $ef4a550e6b2df9e9$var$func = $lVx1a('map', (parcelRequire("80afZ")));

$ef4a550e6b2df9e9$var$func.placeholder = (parcelRequire("aPsMW"));
module.exports = $ef4a550e6b2df9e9$var$func;

});

parcelRegister("CSK1u", function(module, exports) {

$parcel$export(module.exports, "getActiveTab", () => $3dbb60269966cc43$export$65f5dad1c8b348cd);
$parcel$export(module.exports, "getSelectedApplicationType", () => $3dbb60269966cc43$export$89d32e1908ffbe6f);
$parcel$export(module.exports, "isCreatingPullRequestFromDiscovery", () => $3dbb60269966cc43$export$c1036e3a0400aebe);
const $3dbb60269966cc43$var$getUi = (state)=>state.ui;
const $3dbb60269966cc43$export$65f5dad1c8b348cd = (state)=>$3dbb60269966cc43$var$getUi(state).activeTab;
const $3dbb60269966cc43$export$89d32e1908ffbe6f = (state)=>$3dbb60269966cc43$var$getUi(state).selectedApplicationType;
const $3dbb60269966cc43$export$c1036e3a0400aebe = (state)=>$3dbb60269966cc43$var$getUi(state).isCreatingPullRequestFromDiscovery;

});



parcelRegister("jaBqM", function(module, exports) {

$parcel$export(module.exports, "getBuildProviders", () => $6634e8da197824d8$export$6a063eb90049a9f9);
$parcel$export(module.exports, "getBuildsCount", () => $6634e8da197824d8$export$37fe964fd70bc325);
$parcel$export(module.exports, "hasBuilds", () => $6634e8da197824d8$export$fa819f9835fb7ab9);

var $dGvGJ = parcelRequire("dGvGJ");

var $1a66N = parcelRequire("1a66N");

var $2HcZQ = parcelRequire("2HcZQ");

var $rwCaG = parcelRequire("rwCaG");

var $ejRbr = parcelRequire("ejRbr");

var $77bcb = parcelRequire("77bcb");
const $6634e8da197824d8$var$filterProvidersWithoutBuilds = (0, (/*@__PURE__*/$parcel$interopDefault($1a66N)))((provider)=>provider.builds.length > 0);
const $6634e8da197824d8$export$6a063eb90049a9f9 = (0, $dGvGJ.createSelector)([
    (0, $77bcb.getAllInstanceTypeDetails)
], (0, (/*@__PURE__*/$parcel$interopDefault($ejRbr)))((0, (/*@__PURE__*/$parcel$interopDefault($2HcZQ)))((0, (/*@__PURE__*/$parcel$interopDefault($rwCaG)))([], 'buildProviders')), $6634e8da197824d8$var$filterProvidersWithoutBuilds));
const $6634e8da197824d8$var$getBuilds = (0, $dGvGJ.createSelector)([
    $6634e8da197824d8$export$6a063eb90049a9f9
], (0, (/*@__PURE__*/$parcel$interopDefault($2HcZQ)))((0, (/*@__PURE__*/$parcel$interopDefault($rwCaG)))([], 'builds')));
const $6634e8da197824d8$export$37fe964fd70bc325 = (0, $dGvGJ.createSelector)([
    $6634e8da197824d8$var$getBuilds
], (builds)=>builds.length);
const $6634e8da197824d8$export$fa819f9835fb7ab9 = (0, $dGvGJ.createSelector)([
    $6634e8da197824d8$export$37fe964fd70bc325
], (count)=>count > 0);

});
parcelRegister("2HcZQ", function(module, exports) {

var $lVx1a = parcelRequire("lVx1a");

var $1f69adbb0c6662ae$var$func = $lVx1a('flatMap', (parcelRequire("chc6P")));

$1f69adbb0c6662ae$var$func.placeholder = (parcelRequire("aPsMW"));
module.exports = $1f69adbb0c6662ae$var$func;

});
parcelRegister("chc6P", function(module, exports) {

var $ekcP3 = parcelRequire("ekcP3");

var $80afZ = parcelRequire("80afZ");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $8f007734a6a4d9ac$var$flatMap(collection, iteratee) {
    return $ekcP3($80afZ(collection, iteratee), 1);
}
module.exports = $8f007734a6a4d9ac$var$flatMap;

});



parcelRegister("dmU03", function(module, exports) {

$parcel$export(module.exports, "getAllRepositories", () => $f9920bf7ee8ea4db$export$40d2f6cdde350698);
$parcel$export(module.exports, "getMultiInstanceRepositoryIds", () => $f9920bf7ee8ea4db$export$f67c422415a712f0);
$parcel$export(module.exports, "multiInstanceHasCommits", () => $f9920bf7ee8ea4db$export$5113ae74ec2e3a4d);
$parcel$export(module.exports, "hasBitbucketCommits", () => $f9920bf7ee8ea4db$export$c46d71e82fd3f0d3);
$parcel$export(module.exports, "hasEmptyDiffstatForBitbucket", () => $f9920bf7ee8ea4db$export$3249832cb7ef2c30);
$parcel$export(module.exports, "getAllCommitsCount", () => $f9920bf7ee8ea4db$export$492f2f301fb0fce5);
$parcel$export(module.exports, "hasEmptyDiffstatForAnyRepositories", () => $f9920bf7ee8ea4db$export$6016129de20acc3a);
$parcel$export(module.exports, "getMultiInstanceRepositoriesForId", () => $f9920bf7ee8ea4db$export$73edbe998d3a980c);
$parcel$export(module.exports, "multiInstanceHasDiffstat", () => $f9920bf7ee8ea4db$export$4e94c174ed0b6706);
$parcel$export(module.exports, "getMultiInstanceCommitForRepositoryIdAndCommitId", () => $f9920bf7ee8ea4db$export$14961bb097a30129);

var $dGvGJ = parcelRequire("dGvGJ");

var $chc6P = parcelRequire("chc6P");

var $183uB = parcelRequire("183uB");

var $4Xk2W = parcelRequire("4Xk2W");

var $dPSWJ = parcelRequire("dPSWJ");

var $7qDUb = parcelRequire("7qDUb");

var $77bcb = parcelRequire("77bcb");
const $f9920bf7ee8ea4db$var$transformToRepositoriesArray = (instanceTypeDetails)=>instanceTypeDetails ? (0, (/*@__PURE__*/$parcel$interopDefault($183uB)))(instanceTypeDetails.map((instanceTypeDetail)=>(0, (/*@__PURE__*/$parcel$interopDefault($183uB)))(instanceTypeDetail.repositories))) : [];
const $f9920bf7ee8ea4db$export$40d2f6cdde350698 = (0, $dGvGJ.createSelector)([
    (0, $77bcb.getAllInstanceTypeDetails)
], $f9920bf7ee8ea4db$var$transformToRepositoriesArray);
const $f9920bf7ee8ea4db$export$f594c030cdaac8cb = (0, $dGvGJ.createSelector)([
    (0, $77bcb.getSelectedInstanceTypeDetails)
], $f9920bf7ee8ea4db$var$transformToRepositoriesArray);
const $f9920bf7ee8ea4db$export$767ae3b5a7add336 = (0, $dGvGJ.createSelector)([
    (0, $77bcb.getInstanceTypeDetailsByType)
], (detailsByType)=>{
    const bitbucketDetails = detailsByType.bitbucket;
    return bitbucketDetails ? $f9920bf7ee8ea4db$var$transformToRepositoriesArray([
        bitbucketDetails
    ]) : [];
});
const $f9920bf7ee8ea4db$export$1cc6d83b3e47d08b = (0, $dGvGJ.createSelector)([
    $f9920bf7ee8ea4db$export$f594c030cdaac8cb
], (repositories)=>(0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(repositories, 'name').map((repo)=>repo.id));
const $f9920bf7ee8ea4db$export$f67c422415a712f0 = (0, $dGvGJ.createSelector)([
    $f9920bf7ee8ea4db$export$40d2f6cdde350698
], (repositories)=>(0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(repositories, 'name').map((repo)=>repo.id));
const $f9920bf7ee8ea4db$var$hasCommitsInRepos = (repositories)=>(0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(repositories, (repo)=>repo.commits).length > 0;
const $f9920bf7ee8ea4db$export$1048c611ef735231 = (0, $dGvGJ.createSelector)([
    $f9920bf7ee8ea4db$export$f594c030cdaac8cb
], $f9920bf7ee8ea4db$var$hasCommitsInRepos);
const $f9920bf7ee8ea4db$export$5113ae74ec2e3a4d = (0, $dGvGJ.createSelector)([
    $f9920bf7ee8ea4db$export$40d2f6cdde350698
], $f9920bf7ee8ea4db$var$hasCommitsInRepos);
const $f9920bf7ee8ea4db$export$c46d71e82fd3f0d3 = (0, $dGvGJ.createSelector)([
    $f9920bf7ee8ea4db$export$767ae3b5a7add336
], $f9920bf7ee8ea4db$var$hasCommitsInRepos);
const $f9920bf7ee8ea4db$export$3249832cb7ef2c30 = (0, $dGvGJ.createSelector)([
    $f9920bf7ee8ea4db$export$767ae3b5a7add336
], (repositories)=>(0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(repositories, (repo)=>repo.commits).map((commit)=>commit.fileCount).filter((fileCount)=>!fileCount).length > 0);
const $f9920bf7ee8ea4db$export$492f2f301fb0fce5 = (0, $dGvGJ.createSelector)([
    $f9920bf7ee8ea4db$export$40d2f6cdde350698
], (repositories)=>(0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(repositories, (repo)=>repo.commits).length);
const $f9920bf7ee8ea4db$export$6016129de20acc3a = (0, $dGvGJ.createSelector)([
    $f9920bf7ee8ea4db$export$40d2f6cdde350698
], (repositories)=>repositories && repositories.length > 0 && repositories.some((repository)=>repository.commits.some((commit)=>!commit.fileCount)));
const $f9920bf7ee8ea4db$var$getRepositoriesById = (0, $dGvGJ.createSelector)([
    $f9920bf7ee8ea4db$export$f594c030cdaac8cb
], (repositories)=>(0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(repositories, (repository)=>repository.id));
const $f9920bf7ee8ea4db$var$getMultiInstanceRepositoriesById = (0, $dGvGJ.createSelector)([
    $f9920bf7ee8ea4db$export$40d2f6cdde350698
], (repositories)=>(0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(repositories, (repository)=>repository.id));
const $f9920bf7ee8ea4db$export$f1678251e3586c3f = (state, id)=>$f9920bf7ee8ea4db$var$getRepositoriesById(state)[id];
const $f9920bf7ee8ea4db$export$73edbe998d3a980c = (state, id)=>$f9920bf7ee8ea4db$var$getMultiInstanceRepositoriesById(state)[id];
const $f9920bf7ee8ea4db$export$a2bbcbabd13a4854 = (state, id)=>$f9920bf7ee8ea4db$export$f1678251e3586c3f(state, id).commits.some((commit)=>commit.fileCount);
const $f9920bf7ee8ea4db$export$4e94c174ed0b6706 = (state, id)=>$f9920bf7ee8ea4db$export$73edbe998d3a980c(state, id).commits.some((commit)=>commit.fileCount);
const $f9920bf7ee8ea4db$var$getCommitsByRepositoriesById = (0, $dGvGJ.createSelector)([
    $f9920bf7ee8ea4db$var$getRepositoriesById
], (repositories)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(repositories, ({ commits: commits })=>(0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(commits, (commit)=>commit.id)));
const $f9920bf7ee8ea4db$var$getMultiInstanceCommitsByRepositoriesById = (0, $dGvGJ.createSelector)([
    $f9920bf7ee8ea4db$var$getMultiInstanceRepositoriesById
], (repositories)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(repositories, ({ commits: commits })=>(0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(commits, (commit)=>commit.id)));
const $f9920bf7ee8ea4db$export$a155de9a09f1ae7f = (state, repositoryId, id)=>{
    const repository = $f9920bf7ee8ea4db$var$getCommitsByRepositoriesById(state)[repositoryId];
    return (repository || {})[id];
};
const $f9920bf7ee8ea4db$export$14961bb097a30129 = (state, repositoryId, id)=>{
    const repository = $f9920bf7ee8ea4db$var$getMultiInstanceCommitsByRepositoriesById(state)[repositoryId];
    return (repository || {})[id];
};

});

parcelRegister("3AV3y", function(module, exports) {

$parcel$export(module.exports, "getDeploymentsByEnvironmentTypes", () => $d4d57af80dc9971f$export$c9e16e5430d50d52);
$parcel$export(module.exports, "getShowDeploymentTypeHeader", () => $d4d57af80dc9971f$export$cb2ab1c10ada445c);
$parcel$export(module.exports, "getDeploymentsCount", () => $d4d57af80dc9971f$export$5293cb68c5e86e85);
$parcel$export(module.exports, "hasDeployments", () => $d4d57af80dc9971f$export$feabb47efebd957);
$parcel$export(module.exports, "getLatestDeployment", () => $d4d57af80dc9971f$export$8198b9b4efbc776e);

var $dGvGJ = parcelRequire("dGvGJ");

var $2HcZQ = parcelRequire("2HcZQ");

var $rwCaG = parcelRequire("rwCaG");

var $fn8B5 = parcelRequire("fn8B5");

var $80afZ = parcelRequire("80afZ");

var $1AkQu = parcelRequire("1AkQu");

var $7qDUb = parcelRequire("7qDUb");


var $77bcb = parcelRequire("77bcb");
const $d4d57af80dc9971f$var$environmentTypeScore = {
    [(0, $ed461637e46aec23$export$42dd0cdd351a4a9)]: 1,
    [(0, $ed461637e46aec23$export$a739cd5aac835909)]: 2,
    [(0, $ed461637e46aec23$export$5d789bb7ceeee381)]: 3,
    [(0, $ed461637e46aec23$export$23da285852fc57fc)]: 4,
    [(0, $ed461637e46aec23$export$a404d8a18351cf3e)]: 5
};
const $d4d57af80dc9971f$var$getDeploymentProviders = (0, $dGvGJ.createSelector)([
    (0, $77bcb.getDetailsState)
], (detailsState)=>detailsState.details.deploymentProviders);
const $d4d57af80dc9971f$var$getDeployments = (0, $dGvGJ.createSelector)([
    $d4d57af80dc9971f$var$getDeploymentProviders
], (0, (/*@__PURE__*/$parcel$interopDefault($2HcZQ)))((0, (/*@__PURE__*/$parcel$interopDefault($rwCaG)))([], 'deployments')));
const $d4d57af80dc9971f$var$getTypeScore = (deploymentsByEnvironment)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<EnvironmentType, number>>'.
    $d4d57af80dc9971f$var$environmentTypeScore[deploymentsByEnvironment.type];
const $d4d57af80dc9971f$var$sortDeployments = (deployments)=>(0, (/*@__PURE__*/$parcel$interopDefault($1AkQu)))(deployments, 'lastUpdated', 'desc');
const $d4d57af80dc9971f$var$groupByEnvironment = (allDeployments)=>(0, (/*@__PURE__*/$parcel$interopDefault($80afZ)))((0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(allDeployments, (deployment)=>deployment.environment.type), (deployments, type)=>({
            type: type,
            deployments: $d4d57af80dc9971f$var$sortDeployments(deployments)
        }));
const $d4d57af80dc9971f$export$c9e16e5430d50d52 = (0, $dGvGJ.createSelector)([
    $d4d57af80dc9971f$var$getDeployments
], (allDeployments)=>(0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))($d4d57af80dc9971f$var$groupByEnvironment(allDeployments), $d4d57af80dc9971f$var$getTypeScore));
const $d4d57af80dc9971f$export$cb2ab1c10ada445c = (0, $dGvGJ.createSelector)([
    $d4d57af80dc9971f$export$c9e16e5430d50d52
], (allDeploymentTypes)=>allDeploymentTypes.length !== 1 || allDeploymentTypes[0].type !== 'UNMAPPED');
const $d4d57af80dc9971f$export$5293cb68c5e86e85 = (state)=>$d4d57af80dc9971f$var$getDeployments(state).length;
const $d4d57af80dc9971f$export$feabb47efebd957 = (state)=>$d4d57af80dc9971f$export$5293cb68c5e86e85(state) > 0;
const $d4d57af80dc9971f$export$8198b9b4efbc776e = (0, $dGvGJ.createSelector)([
    $d4d57af80dc9971f$export$c9e16e5430d50d52
], (allDeploymentTypes)=>allDeploymentTypes?.[0]?.deployments?.[0] ?? null);

});
parcelRegister("fn8B5", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $4CZTG = parcelRequire("4CZTG");
/** Used for built-in method references. */ var $b30fac385487af61$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b30fac385487af61$var$hasOwnProperty = $b30fac385487af61$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $b30fac385487af61$var$groupBy = $4CZTG(function(result, value, key) {
    if ($b30fac385487af61$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $1m3dq(result, key, [
        value
    ]);
});
module.exports = $b30fac385487af61$var$groupBy;

});

parcelRegister("1AkQu", function(module, exports) {

var $kE90z = parcelRequire("kE90z");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */ function $127952ba7d4c15a6$var$orderBy(collection, iteratees, orders, guard) {
    if (collection == null) return [];
    if (!$8LQ84(iteratees)) iteratees = iteratees == null ? [] : [
        iteratees
    ];
    orders = guard ? undefined : orders;
    if (!$8LQ84(orders)) orders = orders == null ? [] : [
        orders
    ];
    return $kE90z(collection, iteratees, orders);
}
module.exports = $127952ba7d4c15a6$var$orderBy;

});


parcelRegister("g1a7N", function(module, exports) {

$parcel$export(module.exports, "getAllPullRequests", () => $492655d2db9441d2$export$ab04ae017c0b8f3c);
$parcel$export(module.exports, "getMultiInstanceTypePullRequestsGroupByRepoName", () => $492655d2db9441d2$export$beca9e2e23ad385f);
$parcel$export(module.exports, "getMultiInstancePullRequestForId", () => $492655d2db9441d2$export$6059e4d9b1f501ed);
$parcel$export(module.exports, "multiInstanceHasPullRequests", () => $492655d2db9441d2$export$5d7f343387e155d9);

var $dGvGJ = parcelRequire("dGvGJ");

var $hN6Bx = parcelRequire("hN6Bx");

var $rwCaG = parcelRequire("rwCaG");

var $kxJGV = parcelRequire("kxJGV");

var $1ROLB = parcelRequire("1ROLB");

var $ejRbr = parcelRequire("ejRbr");

var $hnySw = parcelRequire("hnySw");

var $4Xk2W = parcelRequire("4Xk2W");


var $77bcb = parcelRequire("77bcb");
const $492655d2db9441d2$var$getDanglingPullRequestOrNothing = (0, (/*@__PURE__*/$parcel$interopDefault($rwCaG)))([], 'danglingPullRequests');
const $492655d2db9441d2$var$getReposPullRequests = (0, (/*@__PURE__*/$parcel$interopDefault($ejRbr)))((0, (/*@__PURE__*/$parcel$interopDefault($rwCaG)))([], 'repositories'), (0, (/*@__PURE__*/$parcel$interopDefault($kxJGV)))((0, (/*@__PURE__*/$parcel$interopDefault($rwCaG)))([], 'pullRequests')));
const $492655d2db9441d2$var$statusScore = {
    [(0, $ed461637e46aec23$export$bb29a81b503a982c)]: 1,
    [(0, $ed461637e46aec23$export$26d1e2e6f089e8e4)]: 2,
    [(0, $ed461637e46aec23$export$2fda0856fe66a3c9)]: 3
};
const $492655d2db9441d2$var$getStatusScore = (pullRequest)=>$492655d2db9441d2$var$statusScore[pullRequest.status];
const $492655d2db9441d2$var$getInstanceTypeDetailsPullRequests = (0, (/*@__PURE__*/$parcel$interopDefault($ejRbr)))((0, (/*@__PURE__*/$parcel$interopDefault($hN6Bx)))((0, (/*@__PURE__*/$parcel$interopDefault($1ROLB)))([
    $492655d2db9441d2$var$getReposPullRequests,
    $492655d2db9441d2$var$getDanglingPullRequestOrNothing
])), (0, (/*@__PURE__*/$parcel$interopDefault($hnySw)))($492655d2db9441d2$var$getStatusScore));
const $492655d2db9441d2$export$89579874f56fc99d = (0, $dGvGJ.createSelector)((0, $77bcb.getSelectedInstanceTypeDetails), $492655d2db9441d2$var$getInstanceTypeDetailsPullRequests);
const $492655d2db9441d2$export$ab04ae017c0b8f3c = (0, $dGvGJ.createSelector)((0, $77bcb.getAllInstanceTypeDetails), $492655d2db9441d2$var$getInstanceTypeDetailsPullRequests);
const $492655d2db9441d2$export$beca9e2e23ad385f = (0, $dGvGJ.createSelector)([
    (0, $77bcb.getAllInstanceTypeDetails)
], (allInstanceTypeDetails)=>allInstanceTypeDetails.reduce((acc, instanceDetail)=>{
        const pullRequests = $492655d2db9441d2$var$getInstanceTypeDetailsPullRequests([
            instanceDetail
        ]);
        pullRequests.forEach((pullrequest)=>{
            const key = `${pullrequest.repositoryName}-${instanceDetail.typeName}`;
            if (!acc[key]) acc[key] = {
                providerId: instanceDetail.id,
                instanceName: instanceDetail.typeName,
                repositoryId: pullrequest.repositoryId,
                repositoryName: pullrequest.repositoryName,
                repositoryUrl: pullrequest.repositoryUrl,
                repositoryAvatarUrl: pullrequest.repositoryAvatarUrl,
                pullRequests: []
            };
            acc[key].pullRequests.push(pullrequest);
        });
        return acc;
    }, {}));
const $492655d2db9441d2$var$getPullRequestById = (0, $dGvGJ.createSelector)([
    $492655d2db9441d2$export$89579874f56fc99d
], (pullRequests)=>(0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(pullRequests, (pullRequest)=>pullRequest.uid));
const $492655d2db9441d2$var$getMultiInstancePullRequestById = (0, $dGvGJ.createSelector)([
    $492655d2db9441d2$export$ab04ae017c0b8f3c
], (pullRequests)=>(0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(pullRequests, (pullRequest)=>pullRequest.uid));
const $492655d2db9441d2$export$2eabaf76224fd65 = (state, id)=>$492655d2db9441d2$var$getPullRequestById(state)[id];
const $492655d2db9441d2$export$6059e4d9b1f501ed = (state, id)=>$492655d2db9441d2$var$getMultiInstancePullRequestById(state)[id];
const $492655d2db9441d2$export$5637cc948831a9a7 = (state)=>$492655d2db9441d2$export$89579874f56fc99d(state).length > 0;
const $492655d2db9441d2$export$5d7f343387e155d9 = (state)=>$492655d2db9441d2$export$ab04ae017c0b8f3c(state).length > 0;

});
parcelRegister("1ROLB", function(module, exports) {

var $lVx1a = parcelRequire("lVx1a");

var $15c21ee5f18a0eee$var$func = $lVx1a('over', (parcelRequire("3J7A9")));

$15c21ee5f18a0eee$var$func.placeholder = (parcelRequire("aPsMW"));
module.exports = $15c21ee5f18a0eee$var$func;

});
parcelRegister("3J7A9", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $26l4f = parcelRequire("26l4f");
/**
 * Creates a function that invokes `iteratees` with the arguments it receives
 * and returns their results.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to invoke.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.over([Math.max, Math.min]);
 *
 * func(1, 2, 3, 4);
 * // => [4, 1]
 */ var $2b6b74bc7454a005$var$over = $26l4f($1nIHN);
module.exports = $2b6b74bc7454a005$var$over;

});
parcelRegister("26l4f", function(module, exports) {

var $hlchF = parcelRequire("hlchF");

var $1nIHN = parcelRequire("1nIHN");

var $bxDef = parcelRequire("bxDef");

var $g7i7g = parcelRequire("g7i7g");

var $cW28x = parcelRequire("cW28x");

var $9SRAA = parcelRequire("9SRAA");
/**
 * Creates a function like `_.over`.
 *
 * @private
 * @param {Function} arrayFunc The function to iterate over iteratees.
 * @returns {Function} Returns the new over function.
 */ function $187c7be00dd5592c$var$createOver(arrayFunc) {
    return $9SRAA(function(iteratees) {
        iteratees = $1nIHN(iteratees, $cW28x($bxDef));
        return $g7i7g(function(args) {
            var thisArg = this;
            return arrayFunc(iteratees, function(iteratee) {
                return $hlchF(iteratee, thisArg, args);
            });
        });
    });
}
module.exports = $187c7be00dd5592c$var$createOver;

});



parcelRegister("hnySw", function(module, exports) {

var $lVx1a = parcelRequire("lVx1a");

var $ca6fa3c27e03c685$var$func = $lVx1a('sortBy', (parcelRequire("7qDUb")));

$ca6fa3c27e03c685$var$func.placeholder = (parcelRequire("aPsMW"));
module.exports = $ca6fa3c27e03c685$var$func;

});


parcelRegister("6j0Io", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $cc4304a89f6fdf9d$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "getRemoteLinksByType", () => $cc4304a89f6fdf9d$export$afc511e2c997e9c);
$parcel$export(module.exports, "getRemoteLinkProvidersCount", () => $cc4304a89f6fdf9d$export$d1b24cd0f6c9b80c);
$parcel$export(module.exports, "getRemoteLinksTotalCount", () => $cc4304a89f6fdf9d$export$93511f509c82200a);
$parcel$export(module.exports, "getRemoteLinksSummary", () => $cc4304a89f6fdf9d$export$edc1195c568f453f);

var $dGvGJ = parcelRequire("dGvGJ");

var $4iiE6 = parcelRequire("4iiE6");

var $kxJGV = parcelRequire("kxJGV");

var $ejRbr = parcelRequire("ejRbr");

var $8GOx7 = parcelRequire("8GOx7");

var $1eZe6 = parcelRequire("1eZe6");

var $77bcb = parcelRequire("77bcb");
const $cc4304a89f6fdf9d$export$68132327813bd90 = (0, $dGvGJ.createSelector)((0, $77bcb.getDetailsState), (details)=>details.details.remoteLinkInformation ? details.details.remoteLinkInformation : {
        numProviders: 0,
        remoteLinksByType: {}
    });
const $cc4304a89f6fdf9d$export$dd1bc94b04021eeb = (0, $dGvGJ.createSelector)($cc4304a89f6fdf9d$export$68132327813bd90, (remoteLinksInfo)=>Object.keys(remoteLinksInfo.remoteLinksByType).length === 0);
const $cc4304a89f6fdf9d$export$afc511e2c997e9c = (0, $dGvGJ.createSelector)($cc4304a89f6fdf9d$export$68132327813bd90, (remoteLinkInfo = {})=>{
    const { remoteLinksByType: remoteLinksByType } = remoteLinkInfo;
    return Object.keys(remoteLinksByType).reduce((remoteLinks, type)=>{
        if (!remoteLinksByType[type]) return remoteLinks;
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"other" | "security" | "alert" | "document" | "test" | "logFile" | "prototype" | "coverage" | "bugReport"'.
        if ((0, $1eZe6.REMOTE_LINK_TYPES).includes(type)) remoteLinks.push({
            remoteLinkType: type,
            // @ts-expect-error - TS2322 - Type 'RemoteLink[]' is not assignable to type 'never[]'.
            remoteLinks: remoteLinksByType[type]
        });
        else // it's unknown - add it to the object with all unknowns
        // @ts-expect-error - TS2345 - Argument of type 'RemoteLink' is not assignable to parameter of type 'never'.
        remoteLinks[0].remoteLinks.push(...remoteLinksByType[type]);
        return remoteLinks;
    }, [
        {
            remoteLinkType: 'unknown',
            remoteLinks: []
        }
    ]).filter((remoteLinks)=>remoteLinks.remoteLinks.length > 0);
});
const $cc4304a89f6fdf9d$export$be64678a6f02e2d2 = (0, $dGvGJ.createSelector)($cc4304a89f6fdf9d$export$68132327813bd90, (0, (/*@__PURE__*/$parcel$interopDefault($ejRbr)))((remoteLinkInfo)=>remoteLinkInfo.remoteLinksByType, (0, (/*@__PURE__*/$parcel$interopDefault($kxJGV)))('remoteLinks'), (0, (/*@__PURE__*/$parcel$interopDefault($4iiE6))), (0, (/*@__PURE__*/$parcel$interopDefault($kxJGV)))('provider.id'), (0, (/*@__PURE__*/$parcel$interopDefault($8GOx7)))));
const $cc4304a89f6fdf9d$export$d1b24cd0f6c9b80c = (0, $dGvGJ.createSelector)($cc4304a89f6fdf9d$export$68132327813bd90, (remoteLinkInfo)=>remoteLinkInfo.numProviders);
const $cc4304a89f6fdf9d$export$93511f509c82200a = (0, $dGvGJ.createSelector)($cc4304a89f6fdf9d$export$68132327813bd90, (remoteLinkInfo)=>Object.keys(remoteLinkInfo.remoteLinksByType).reduce((acc, remoteLinkType)=>acc + remoteLinkInfo.remoteLinksByType[remoteLinkType].length, 0));
const $cc4304a89f6fdf9d$export$edc1195c568f453f = (0, $dGvGJ.createSelector)($cc4304a89f6fdf9d$export$68132327813bd90, (remoteLinkInfo)=>{
    const links = [];
    Object.keys(remoteLinkInfo.remoteLinksByType).forEach((type)=>{
        remoteLinkInfo.remoteLinksByType[type].forEach((link)=>{
            links.push({
                RemoteLinkId: link.id,
                RemoteLinkProviderId: link.provider.id,
                RemoteLinkProviderName: link.provider.name,
                RemoteLinkType: link.type,
                RemoteLinkStatus: link.status ? link.status.label : '',
                RemoteLinkDescription: link.description ? link.description : ''
            });
        });
    });
    return links;
});

});
parcelRegister("4iiE6", function(module, exports) {

var $lVx1a = parcelRequire("lVx1a");


var $32074e864909e069$var$func = $lVx1a('flatten', (parcelRequire("183uB")), (parcelRequire("bUoRH")));

$32074e864909e069$var$func.placeholder = (parcelRequire("aPsMW"));
module.exports = $32074e864909e069$var$func;

});
parcelRegister("bUoRH", function(module, exports) {
module.exports = {
    'cap': false,
    'curry': false,
    'fixed': false,
    'immutable': false,
    'rearg': false
};

});


parcelRegister("8GOx7", function(module, exports) {

var $lVx1a = parcelRequire("lVx1a");


var $653971d100474755$var$func = $lVx1a('uniq', (parcelRequire("kGsr8")), (parcelRequire("bUoRH")));

$653971d100474755$var$func.placeholder = (parcelRequire("aPsMW"));
module.exports = $653971d100474755$var$func;

});

parcelRegister("1eZe6", function(module, exports) {

$parcel$export(module.exports, "REMOTE_LINK_TYPES", () => $03c26345d33735b0$export$a544329e8f55f05);
const $03c26345d33735b0$export$a544329e8f55f05 = [
    'document',
    'alert',
    'test',
    'security',
    'logFile',
    'prototype',
    'coverage',
    'bugReport',
    'releaseNotes',
    'other'
];

});





parcelRegister("jP4SE", function(module, exports) {

$parcel$export(module.exports, "epic", () => $0a715b443cf95849$export$8ec5145af6f76965);
parcelRequire("fPS7b");
parcelRequire("1oQta");


var $kw5c5 = parcelRequire("kw5c5");

var $hBYWk = parcelRequire("hBYWk");

var $dmU03 = parcelRequire("dmU03");

var $77bcb = parcelRequire("77bcb");

var $CSK1u = parcelRequire("CSK1u");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0a715b443cf95849$var$diffstatAnalyticEventOrNull = (state)=>{
    const shouldFireDiffstatAnalytics = !(0, $77bcb.isDiffstatAnalyticsFired)(state) && (0, $CSK1u.getActiveTab)(state) === (0, $61a2cd6236d50c20$export$2e42513c7764d5f3) && (0, $dmU03.hasBitbucketCommits)(state);
    return shouldFireDiffstatAnalytics ? (0, $kw5c5.fireBitbucketDiffstatAnalyticsEvent)() : null;
};
const $0a715b443cf95849$var$eventsMappers = {
    // @ts-expect-error - TS7006 - Parameter 'action' implicitly has an 'any' type. | TS7006 - Parameter 'state' implicitly has an 'any' type.
    [(0, $kw5c5.SET_DETAIL_DATA)]: (action, state)=>[
            (0, $kw5c5.fireDetailDataFetchedEvent)(action.payload),
            $0a715b443cf95849$var$diffstatAnalyticEventOrNull(state)
        ],
    // @ts-expect-error - TS7006 - Parameter 'action' implicitly has an 'any' type. | TS7006 - Parameter 'state' implicitly has an 'any' type.
    [(0, $hBYWk.CHANGE_TAB)]: (action, state)=>[
            $0a715b443cf95849$var$diffstatAnalyticEventOrNull(state)
        ]
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0a715b443cf95849$var$getNewActions = (action, store)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly "state.actions.details.SET_DETAIL_DATA": (action: any, state: any) => (FireDetailDataFetchedEventAction | FireBitbucketDiffstatAnalyticsEventAction | null)[]; readonly "state.actions.ui.CHANGE_TAB": (action: any, state: any) => (FireBitbucketDiffstatAnalyticsEventAction | null)[]; }'. | TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly "state.actions.details.SET_DETAIL_DATA": (action: any, state: any) => (FireDetailDataFetchedEventAction | FireBitbucketDiffstatAnalyticsEventAction | null)[]; readonly "state.actions.ui.CHANGE_TAB": (action: any, state: any) => (FireBitbucketDiffstatAnalyticsEventAction | null)[]; }'.
    $0a715b443cf95849$var$eventsMappers[action.type] && $0a715b443cf95849$var$eventsMappers[action.type](action, store) || [];
const $0a715b443cf95849$export$8ec5145af6f76965 = (action$, store)=>action$.flatMap((action)=>$0a715b443cf95849$var$getNewActions(action, store.getState())).filter((newAction)=>!!newAction);

});
const $61a2cd6236d50c20$export$e18d81f044132a0e = 'branch';
const $61a2cd6236d50c20$export$74a388a09f2a004e = 'build';
const $61a2cd6236d50c20$export$2e42513c7764d5f3 = 'repository';
const $61a2cd6236d50c20$export$3f1e2b276d607490 = 'review';
const $61a2cd6236d50c20$export$90cac6260ae9ced5 = 'deployment-environment';
const $61a2cd6236d50c20$export$6f74b53d652f13f3 = 'pullrequest';
const $61a2cd6236d50c20$export$c69477f358d30f7e = 'feature-flags';
const $61a2cd6236d50c20$export$56470bdd9cd798d0 = 'remote-links';
const $61a2cd6236d50c20$export$b4bb784d069c9ab = 'development.details.details-header';

parcelRegister("hBYWk", function(module, exports) {

$parcel$export(module.exports, "CHANGE_TAB", () => $3328eb83c9d46095$export$a47987c4210b1f64);
$parcel$export(module.exports, "changeTab", () => $3328eb83c9d46095$export$595e5d7be493cad3);
$parcel$export(module.exports, "SET_SELECTED_APPLICATION_TYPE", () => $3328eb83c9d46095$export$7efca4d99d61577a);
$parcel$export(module.exports, "setSelectedApplicationType", () => $3328eb83c9d46095$export$959e9e5b05ba3981);
$parcel$export(module.exports, "OPEN_PULL_REQUEST_CREATION_DISCOVERY", () => $3328eb83c9d46095$export$8e35f3f909f3560f);
$parcel$export(module.exports, "openPullRequestCreationDiscovery", () => $3328eb83c9d46095$export$5be9ed3e28a3477c);
$parcel$export(module.exports, "CLOSE_PULL_REQUEST_CREATION_DISCOVERY", () => $3328eb83c9d46095$export$57d52469ed51b520);
$parcel$export(module.exports, "closePullRequestCreationDiscovery", () => $3328eb83c9d46095$export$26193fce85ab99e0);
const $3328eb83c9d46095$export$a47987c4210b1f64 = 'state.actions.ui.CHANGE_TAB';
const $3328eb83c9d46095$export$595e5d7be493cad3 = (activeTab)=>({
        type: $3328eb83c9d46095$export$a47987c4210b1f64,
        payload: {
            activeTab: activeTab
        }
    });
const $3328eb83c9d46095$export$7efca4d99d61577a = 'state.actions.ui.SET_SELECTED_APPLICATION_TYPE';
const $3328eb83c9d46095$export$959e9e5b05ba3981 = (selectedApplicationType)=>({
        type: $3328eb83c9d46095$export$7efca4d99d61577a,
        payload: {
            selectedApplicationType: selectedApplicationType
        }
    });
const $3328eb83c9d46095$export$8e35f3f909f3560f = 'state.actions.ui.OPEN_PULL_REQUEST_CREATION_DISCOVERY';
const $3328eb83c9d46095$export$5be9ed3e28a3477c = ()=>({
        type: $3328eb83c9d46095$export$8e35f3f909f3560f
    });
const $3328eb83c9d46095$export$57d52469ed51b520 = 'state.actions.ui.CLOSE_PULL_REQUEST_CREATION_DISCOVERY';
const $3328eb83c9d46095$export$26193fce85ab99e0 = ()=>({
        type: $3328eb83c9d46095$export$57d52469ed51b520
    });

});


parcelRegister("hg7ZY", function(module, exports) {

$parcel$export(module.exports, "epic", () => $64b3ab01de8a67f5$export$8ec5145af6f76965);
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");


var $hBYWk = parcelRequire("hBYWk");

var $9gkiu = parcelRequire("9gkiu");

var $CSK1u = parcelRequire("CSK1u");
const $64b3ab01de8a67f5$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $hBYWk.CHANGE_TAB)).mergeMap(()=>{
        const state = store.getState();
        const activeTab = (0, $CSK1u.getActiveTab)(state);
        switch(activeTab){
            case 0, $61a2cd6236d50c20$export$e18d81f044132a0e:
            case 0, $61a2cd6236d50c20$export$2e42513c7764d5f3:
            case 0, $61a2cd6236d50c20$export$6f74b53d652f13f3:
                {
                    const applicationTypes = (0, $9gkiu.getApplicationTypes)(activeTab)(state);
                    return (0, $kVLXA.Observable).of((0, $hBYWk.setSelectedApplicationType)(applicationTypes[0]));
                }
            case 0, $61a2cd6236d50c20$export$56470bdd9cd798d0:
            case 0, $61a2cd6236d50c20$export$c69477f358d30f7e:
                return (0, $kVLXA.Observable).empty();
            case 0, $61a2cd6236d50c20$export$74a388a09f2a004e:
            case 0, $61a2cd6236d50c20$export$90cac6260ae9ced5:
                /* Why hardcode 'bamboo'? This is set to retrieve the error messages within instance types and only
				 * bamboo can have errors from dev status. This is different from commits/branches/pullrequests tab
				 * because we show each instance type and its error message within its own sub tab, but for builds and
				 * deployments, we need to combine Bamboo and Cloud Data into single view and show errors only from Bamboo. */ return (0, $kVLXA.Observable).of((0, $hBYWk.setSelectedApplicationType)('bamboo'));
            default:
                throw new Error(`Unsupported tab type: ${activeTab}`);
        }
    });

});
parcelRegister("9gkiu", function(module, exports) {

$parcel$export(module.exports, "getApplicationTypes", () => $f75906a67fcda8d9$export$1a7ac998ea9f8737);

var $dGvGJ = parcelRequire("dGvGJ");

var $1sWm7 = parcelRequire("1sWm7");

var $6eBRn = parcelRequire("6eBRn");

var $gccSB = parcelRequire("gccSB");

var $3JOCw = parcelRequire("3JOCw");


var $77bcb = parcelRequire("77bcb");
const $f75906a67fcda8d9$var$panelTypeToDetailsField = {
    [(0, $61a2cd6236d50c20$export$e18d81f044132a0e)]: 'branches',
    [(0, $61a2cd6236d50c20$export$2e42513c7764d5f3)]: 'commits',
    [(0, $61a2cd6236d50c20$export$6f74b53d652f13f3)]: 'pullRequests'
};
const $f75906a67fcda8d9$var$mapInstancesToApplicationSummary = (instances)=>instances.map(({ type: type, name: name })=>({
            type: type,
            name: name
        }));
const $f75906a67fcda8d9$var$filterByPanelTypePredicate = (instance, panelType)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Repository'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly branch: "branches"; readonly repository: "commits"; readonly pullrequest: "pullRequests"; }'.
    !!(0, (/*@__PURE__*/$parcel$interopDefault($1sWm7)))(instance.repositories, (repo)=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(repo[$f75906a67fcda8d9$var$panelTypeToDetailsField[panelType]]));
const $f75906a67fcda8d9$var$filterByDanglingPRsPredicate = (instance, panelType)=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(instance.danglingPullRequests) || $f75906a67fcda8d9$var$filterByPanelTypePredicate(instance, panelType);
const $f75906a67fcda8d9$var$getPanelData = (panelType, instances, // eslint-disable-next-line @typescript-eslint/no-explicit-any
filterFunc)=>[
        panelType,
        (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))($f75906a67fcda8d9$var$mapInstancesToApplicationSummary(instances.filter((instance)=>filterFunc(instance, panelType))), 'type')
    ];
const $f75906a67fcda8d9$var$getApplicationsFromDetails = (0, $dGvGJ.createSelector)([
    (0, $77bcb.getAllInstanceTypeDetails)
], (instances)=>(0, (/*@__PURE__*/$parcel$interopDefault($6eBRn)))([
        $f75906a67fcda8d9$var$getPanelData((0, $61a2cd6236d50c20$export$2e42513c7764d5f3), instances, $f75906a67fcda8d9$var$filterByPanelTypePredicate),
        $f75906a67fcda8d9$var$getPanelData((0, $61a2cd6236d50c20$export$e18d81f044132a0e), instances, $f75906a67fcda8d9$var$filterByPanelTypePredicate),
        $f75906a67fcda8d9$var$getPanelData((0, $61a2cd6236d50c20$export$6f74b53d652f13f3), instances, $f75906a67fcda8d9$var$filterByDanglingPRsPredicate)
    ]));
const $f75906a67fcda8d9$export$33bb3fa8585ccba7 = (panelType)=>(state)=>$f75906a67fcda8d9$var$getApplicationsFromDetails(state)[panelType] || [];
const $f75906a67fcda8d9$export$1a7ac998ea9f8737 = (panelType)=>(state)=>$f75906a67fcda8d9$export$33bb3fa8585ccba7(panelType)(state).map((application)=>application.type);

});
parcelRegister("1sWm7", function(module, exports) {

var $bptzf = parcelRequire("bptzf");

var $fW7cr = parcelRequire("fW7cr");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $1115ac3ae60cc7bc$var$find = $bptzf($fW7cr);
module.exports = $1115ac3ae60cc7bc$var$find;

});
parcelRegister("bptzf", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $hTJwX = parcelRequire("hTJwX");

var $66FNL = parcelRequire("66FNL");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $84e8f705a13e859f$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$hTJwX(collection)) {
            var iteratee = $bxDef(predicate, 3);
            collection = $66FNL(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $84e8f705a13e859f$var$createFind;

});

parcelRegister("fW7cr", function(module, exports) {

var $b5dwA = parcelRequire("b5dwA");

var $bxDef = parcelRequire("bxDef");

var $kPZpS = parcelRequire("kPZpS");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b9a1db7d7901532f$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $b9a1db7d7901532f$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $kPZpS(fromIndex);
    if (index < 0) index = $b9a1db7d7901532f$var$nativeMax(length + index, 0);
    return $b5dwA(array, $bxDef(predicate, 3), index);
}
module.exports = $b9a1db7d7901532f$var$findIndex;

});




parcelRegister("aXVqb", function(module, exports) {

$parcel$export(module.exports, "epic", () => $415406e78904fdaa$export$8ec5145af6f76965);
$parcel$export(module.exports, "optOutDeploymentDetailDiscovery", () => $415406e78904fdaa$export$749833718123995b);
parcelRequire("jFVZ1");
parcelRequire("fp4O3");
parcelRequire("aSIuP");
parcelRequire("9o0uh");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $it1wb = parcelRequire("it1wb");

var $gn1v9 = parcelRequire("gn1v9");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $ckQp9 = parcelRequire("ckQp9");

var $9hfbX = parcelRequire("9hfbX");

var $kw5c5 = parcelRequire("kw5c5");

var $hBYWk = parcelRequire("hBYWk");

var $8Fofq = parcelRequire("8Fofq");
const $415406e78904fdaa$export$2cca46dea398dd67 = ()=>(0, $it1wb.default)((0, $gn1v9.default)(new Date(), {
        weeks: 6
    })).toISOString();
const $415406e78904fdaa$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $kw5c5.FETCH_DETAIL)).mergeMap(()=>{
        const state = store.getState();
        const issueId = (0, $8Fofq.getIssueId)(state);
        const baseUrl = (0, $8Fofq.getBaseUrl)(state);
        const projectAri = (0, $8Fofq.getProjectAri)(state) || '';
        const accountId = (0, $8Fofq.getAccountId)(state) || '';
        const updatedFrom = $415406e78904fdaa$export$2cca46dea398dd67();
        const detailsObservable = (0, $kVLXA.Observable).zip((0, $ckQp9.default)(baseUrl, issueId), (0, $ckQp9.getDeploymentDataDetected)(projectAri, updatedFrom), (0, $9hfbX.getOptOutDeploymentsDiscovery)(accountId), (details, deploymentDataDetected, isOptOutOfDeploymentDiscovery)=>(0, $kw5c5.setDetailData)({
                details: {
                    ...details,
                    embeddedMarketplaceDetails: {
                        ...details.embeddedMarketplaceDetails || {},
                        shouldDisplayForBuilds: details?.embeddedMarketplaceDetails?.shouldDisplayForBuilds || false,
                        shouldDisplayForDeployments: !deploymentDataDetected || details?.embeddedMarketplaceDetails?.shouldDisplayForDeployments || false,
                        shouldDisplayForFeatureFlags: details?.embeddedMarketplaceDetails?.shouldDisplayForFeatureFlags || false
                    }
                },
                isOptOutOfDeploymentDiscovery: isOptOutOfDeploymentDiscovery
            })).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('packages.development.details.src.main.fetch-details', error);
            return (0, $kVLXA.Observable).of((0, $kw5c5.fetchingFailed)());
        });
        return (0, $kVLXA.Observable).concat(detailsObservable, (0, $kVLXA.Observable).of((0, $8Fofq.getSelectedTab)(state)).map((selectedTab)=>(0, $hBYWk.changeTab)(selectedTab)));
    });
const $415406e78904fdaa$export$749833718123995b = (action$, store)=>action$.ofType((0, $kw5c5.OPT_OUT_DEPLOYMENTS_DISCOVERY)).mergeMap(()=>{
        const state = store.getState();
        const accountId = (0, $8Fofq.getAccountId)(state) || '';
        return (0, $kVLXA.Observable).fromPromise((0, $9hfbX.setOptOutDeploymentsDiscovery)(accountId)).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('packages.development.details.src.main.opt-project-out-deployments-ddd-discovery', error);
            return (0, $kVLXA.Observable).empty();
        });
    });

});
parcelRegister("ckQp9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c72111fed83aa865$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getDeploymentDataDetected", () => $c72111fed83aa865$export$ee660826ba4bb836);

var $iWYKb = parcelRequire("iWYKb");

var $8Uumt = parcelRequire("8Uumt");

var $hKyAu = parcelRequire("hKyAu");

var $5yJb9 = parcelRequire("5yJb9");

var $h067l = parcelRequire("h067l");

var $iGw8p = parcelRequire("iGw8p");

var $6Q8ez = parcelRequire("6Q8ez");
const $c72111fed83aa865$var$transformBranchPR = (swagBranchPR)=>({
        ...swagBranchPR
    });
const $c72111fed83aa865$var$transformReview = (swagReview)=>({
        ...swagReview
    });
const $c72111fed83aa865$var$UNAUTHORIZED_ERROR = 'unauthorized';
const $c72111fed83aa865$var$hasUnauthorizedError = (errorMessages = [])=>errorMessages.indexOf($c72111fed83aa865$var$UNAUTHORIZED_ERROR) > -1;
// Make a string for errors
// @ts-expect-error - TS7006 - Parameter 'instanceType' implicitly has an 'any' type.
const $c72111fed83aa865$var$mapErrors = (instanceType)=>{
    const errorMessages = instanceType.devStatusErrorMessages || [];
    if (errorMessages.length && !$c72111fed83aa865$var$hasUnauthorizedError(instanceType.devStatusErrorMessages)) return {
        url: instanceType.baseUrl,
        name: instanceType.name
    };
    return null;
};
// @ts-expect-error - TS7006 - Parameter 'instanceType' implicitly has an 'any' type.
const $c72111fed83aa865$var$mapUnauthorizedLinks = (instanceType)=>{
    if ($c72111fed83aa865$var$hasUnauthorizedError(instanceType.devStatusErrorMessages)) return {
        applicationLinkId: instanceType.id,
        name: instanceType.name
    };
    return null;
};
const $c72111fed83aa865$var$transformInstanceType = (// @ts-expect-error - TS7006 - Parameter 'instanceType' implicitly has an 'any' type.
instanceType, repositories, danglingPullRequests, buildProviders)=>({
        id: instanceType.id,
        name: instanceType.name,
        type: instanceType.type,
        typeName: instanceType.typeName,
        baseUrl: (0, $hKyAu.toSanitizedUrl)(instanceType.baseUrl),
        repositories: repositories,
        danglingPullRequests: danglingPullRequests,
        buildProviders: buildProviders,
        errorLink: $c72111fed83aa865$var$mapErrors(instanceType),
        unauthorizedLink: $c72111fed83aa865$var$mapUnauthorizedLinks(instanceType)
    });
// @ts-expect-error - TS7006 - Parameter 'swagBranch' implicitly has an 'any' type.
const $c72111fed83aa865$var$transformLastCommit = (swagBranch)=>swagBranch.lastCommit ? {
        ...swagBranch.lastCommit,
        id: swagBranch.lastCommit.displayId
    } : null;
const $c72111fed83aa865$export$57ace40be4f3f185 = (instanceType, repository, swagBranch, index)=>({
        id: `${instanceType.id}/${repository.name}/${index}`,
        name: swagBranch.name,
        url: swagBranch.url,
        createPullRequestUrl: swagBranch.createPullRequestUrl,
        createReviewUrl: swagBranch.createReviewUrl,
        pullRequests: swagBranch.pullRequests.map($c72111fed83aa865$var$transformBranchPR),
        reviews: swagBranch.reviews.map($c72111fed83aa865$var$transformReview),
        lastCommit: $c72111fed83aa865$var$transformLastCommit(swagBranch)
    });
const $c72111fed83aa865$export$b613cefff829ae93 = (swagPr, uid)=>({
        ...swagPr,
        uid: uid
    });
const $c72111fed83aa865$var$mapCommitAuthor = (author)=>({
        name: author.name,
        avatar: author.avatarUrl
    });
// @ts-expect-error - TS2304 - Cannot find name 'FileType'.
const $c72111fed83aa865$var$mapCommitFiles = (files)=>files.map((file)=>({
            ...file
        }));
const $c72111fed83aa865$export$91295c968cc19bfb = (swagCommit)=>({
        id: swagCommit.id,
        displayId: swagCommit.displayId,
        url: swagCommit.url,
        createReviewUrl: swagCommit.createReviewUrl,
        message: swagCommit.message,
        authorTimestamp: swagCommit.timestamp,
        author: $c72111fed83aa865$var$mapCommitAuthor(swagCommit.author),
        merge: swagCommit.isMerge,
        fileCount: swagCommit.files.length,
        files: $c72111fed83aa865$var$mapCommitFiles(swagCommit.files)
    });
const $c72111fed83aa865$var$transformPullRequests = (instanceId, pullRequests = [], repositoryName = '__')=>pullRequests.map((pullRequest)=>$c72111fed83aa865$export$b613cefff829ae93(pullRequest, `${instanceId}/${repositoryName}/${pullRequest.id}`))// @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
    .sort((a, b)=>new Date(b.lastUpdate) - new Date(a.lastUpdate));
const $c72111fed83aa865$export$1559ce45255ec471 = (instanceType, repository, repoIndex)=>({
        id: repository.id ?? `${instanceType.id}/${repoIndex}`,
        name: repository.name,
        url: repository.url != null ? (0, $hKyAu.toSanitizedUrl)(repository.url) : null,
        avatar: repository.avatarUrl != null ? (0, $hKyAu.toSanitizedUrl)(repository.avatarUrl) : null,
        description: repository.description,
        instanceName: instanceType.typeName,
        instanceId: instanceType.id,
        branches: repository.branches.map((branch, index)=>$c72111fed83aa865$export$57ace40be4f3f185(instanceType, repository, branch, index)),
        pullRequests: $c72111fed83aa865$var$transformPullRequests(instanceType.id, repository.pullRequests, repository.name),
        commits: repository.commits.map((commit)=>$c72111fed83aa865$export$91295c968cc19bfb(commit))// @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
        .sort((a, b)=>new Date(b.authorTimestamp) - new Date(a.authorTimestamp))
    });
const $c72111fed83aa865$var$transformDanglingPullRequests = (instanceType)=>$c72111fed83aa865$var$transformPullRequests(instanceType.id, instanceType.danglingPullRequests);
const $c72111fed83aa865$export$600c070530945ad8 = (buildProvider)=>({
        id: buildProvider.id,
        name: buildProvider.name,
        url: (0, $hKyAu.toSanitizedUrl)(buildProvider.url),
        description: buildProvider.description,
        avatarUrl: buildProvider.avatarUrl != null ? (0, $hKyAu.toSanitizedUrl)(buildProvider.avatarUrl) : null,
        builds: buildProvider.builds.sort((a, b)=>new Date(b.lastUpdated).valueOf() - new Date(a.lastUpdated).valueOf())
    });
const $c72111fed83aa865$export$1f9e2fed0535e427 = (response)=>{
    const instanceTypes = response.data.developmentInformation.details.instanceTypes.map((instanceType)=>{
        const transformedRepositories = instanceType.repository.map((repository, index)=>$c72111fed83aa865$export$1559ce45255ec471(instanceType, repository, index));
        const transformedDanglingPullRequests = $c72111fed83aa865$var$transformDanglingPullRequests(instanceType);
        const transformedBuildProviders = instanceType.buildProviders.map((buildProvider)=>$c72111fed83aa865$export$600c070530945ad8(buildProvider));
        return $c72111fed83aa865$var$transformInstanceType(instanceType, transformedRepositories, transformedDanglingPullRequests, transformedBuildProviders);
    });
    return instanceTypes;
};
const $c72111fed83aa865$var$transformEnvironment = (environment)=>({
        id: environment.id,
        displayName: environment.displayName,
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'EnvironmentType'.
        type: environment.type
    });
const $c72111fed83aa865$var$transformDeployment = (deployment)=>({
        displayName: deployment.displayName,
        url: deployment.url,
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'DeploymentState'.
        state: deployment.state,
        lastUpdated: deployment.lastUpdated,
        environment: $c72111fed83aa865$var$transformEnvironment(deployment.environment),
        pipelineId: deployment.pipelineId,
        pipelineDisplayName: deployment.pipelineDisplayName,
        pipelineUrl: deployment.pipelineUrl
    });
const $c72111fed83aa865$var$transformDeploymentProvider = (deploymentProvider)=>({
        id: deploymentProvider.id,
        name: deploymentProvider.name,
        homeUrl: (0, $hKyAu.toSanitizedUrl)(deploymentProvider.homeUrl),
        logoUrl: deploymentProvider.logoUrl != null ? (0, $hKyAu.toSanitizedUrl)(deploymentProvider.logoUrl) : null,
        deployments: deploymentProvider.deployments.map((deployment)=>$c72111fed83aa865$var$transformDeployment(deployment))
    });
const $c72111fed83aa865$export$4efd6b08365fb9e7 = (result)=>result.data.developmentInformation.details.deploymentProviders.map((deploymentProvider)=>$c72111fed83aa865$var$transformDeploymentProvider(deploymentProvider));
const $c72111fed83aa865$export$7acea2265cf4ac9c = (response)=>response.data.developmentInformation.details.embeddedMarketplace;
const $c72111fed83aa865$export$f13b29f9ed0c5a03 = (result)=>{
    const { featureFlagProviders: featureFlagProviders, remoteLinksByType: remoteLinksByType } = result.data.developmentInformation.details;
    return {
        instanceTypeDetails: $c72111fed83aa865$export$1f9e2fed0535e427(result),
        deploymentProviders: $c72111fed83aa865$export$4efd6b08365fb9e7(result),
        featureFlags: featureFlagProviders ? (0, $iGw8p.transformFeatureFlags)(featureFlagProviders) : {},
        remoteLinkInformation: remoteLinksByType ? (0, $6Q8ez.transformRemoteLinks)(remoteLinksByType) : {
            numProviders: 0,
            remoteLinksByType: {}
        },
        embeddedMarketplaceDetails: $c72111fed83aa865$export$7acea2265cf4ac9c(result)
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c72111fed83aa865$export$2e2bcd8739ae039 = async (baseUrl, issueId)=>{
    const result = await (0, $h067l.default)(baseUrl, issueId);
    if (result.errors && result.errors.length) {
        const errorMessages = result.errors.map((error)=>error.message).reduce((acc, current)=>`${acc}\n ${current}`, '');
        throw Error(`Error retrieving details from service: ${errorMessages}`);
    }
    try {
        return $c72111fed83aa865$export$f13b29f9ed0c5a03(result);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw Error(`Error creating details, error: ${error}`);
    }
};
const $c72111fed83aa865$export$ee660826ba4bb836 = (projectAri, updatedFrom)=>(0, $8Uumt.fetchQuery)((0, $5yJb9.default)(), (0, $iWYKb.default), {
        projectAri: projectAri,
        updatedFrom: updatedFrom
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise().then((result)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const data = result;
        return (data?.devOps?.ariGraph?.deploymentRelationships?.nodes ?? []).length > 0;
    });

});
parcelRegister("iWYKb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a72190f9f9cb237$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<506f45535620e4112729474229b7d58f>>
 * @relayHash 08c252cc5c3789c2ecbcea82e0174f13
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0ea3a4f7efc5495f47c1aaa78caf8bccb3cd76572d3141b65719532cb23b2e60
const $1a72190f9f9cb237$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "updatedFrom"
        }
    ], v1 = {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
            {
                "concreteType": "AriGraph",
                "kind": "LinkedField",
                "name": "ariGraph",
                "plural": false,
                "selections": [
                    {
                        "alias": "deploymentRelationships",
                        "args": [
                            {
                                "fields": [
                                    {
                                        "kind": "Variable",
                                        "name": "from",
                                        "variableName": "projectAri"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "project-associated-deployment"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "updatedFrom",
                                        "variableName": "updatedFrom"
                                    }
                                ],
                                "kind": "ObjectValue",
                                "name": "filter"
                            },
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 1
                            }
                        ],
                        "concreteType": "AriGraphRelationshipConnection",
                        "kind": "LinkedField",
                        "name": "relationships",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "AriGraphRelationship",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "detailsDeploymentDataDetectedQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v1 /*: any*/ ,
                    "action": "THROW",
                    "path": "devOps"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "detailsDeploymentDataDetectedQuery",
            "selections": [
                v1 /*: any*/ 
            ]
        },
        "params": {
            "id": "0ea3a4f7efc5495f47c1aaa78caf8bccb3cd76572d3141b65719532cb23b2e60",
            "metadata": {},
            "name": "detailsDeploymentDataDetectedQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1a72190f9f9cb237$var$node.hash = "21211370ddb0d181284a4265fae29842";
var $1a72190f9f9cb237$export$2e2bcd8739ae039 = $1a72190f9f9cb237$var$node;

});

parcelRegister("hKyAu", function(module, exports) {

$parcel$export(module.exports, "toSanitizedUrl", () => $048f973bab2ee3ff$export$36fdccbdcd093523);

var $5kchp = parcelRequire("5kchp");
const $048f973bab2ee3ff$export$36fdccbdcd093523 = (url)=>(0, $5kchp.sanitizeUrl)(url);

});
parcelRegister("5kchp", function(module, exports) {
'use strict';
var $3e0858899f98084b$var$invalidPrototcolRegex = /^(%20|\s)*(javascript|data)/im;
var $3e0858899f98084b$var$ctrlCharactersRegex = /[^\x20-\x7E]/gmi;
var $3e0858899f98084b$var$urlSchemeRegex = /^([^:]+):/gm;
var $3e0858899f98084b$var$relativeFirstCharacters = [
    '.',
    '/'
];
function $3e0858899f98084b$var$isRelativeUrl(url) {
    return $3e0858899f98084b$var$relativeFirstCharacters.indexOf(url[0]) > -1;
}
function $3e0858899f98084b$var$sanitizeUrl(url) {
    if (!url) return 'about:blank';
    var urlScheme, urlSchemeParseResults;
    var sanitizedUrl = url.replace($3e0858899f98084b$var$ctrlCharactersRegex, '');
    if ($3e0858899f98084b$var$isRelativeUrl(sanitizedUrl)) return sanitizedUrl;
    urlSchemeParseResults = sanitizedUrl.match($3e0858899f98084b$var$urlSchemeRegex);
    if (!urlSchemeParseResults) return 'about:blank';
    urlScheme = urlSchemeParseResults[0];
    if ($3e0858899f98084b$var$invalidPrototcolRegex.test(urlScheme)) return 'about:blank';
    return sanitizedUrl;
}
module.exports = {
    sanitizeUrl: $3e0858899f98084b$var$sanitizeUrl
};

});


parcelRegister("h067l", function(module, exports) {

$parcel$export(module.exports, "default", () => $92d55c1fa1055bf9$export$2e2bcd8739ae039);

var $cBLvH = parcelRequire("cBLvH");
const $92d55c1fa1055bf9$var$OPERATION_NAME = 'DevDetailsDialog';
const $92d55c1fa1055bf9$var$branchesQuery = `branches {
        name
        url
        createReviewUrl
        createPullRequestUrl
        lastCommit {
            url
            displayId
            timestamp
        }
        pullRequests {
            name
            url
            status
            lastUpdate
        }
        reviews {
            state
            url
            id
        }
    }`;
const $92d55c1fa1055bf9$var$commitsQuery = `commits{
        id
        displayId
        url
        createReviewUrl
        timestamp
        isMerge
        message
        author {
          name
          avatarUrl
        }
        files{
          linesAdded
          linesRemoved
          changeType
          url
          path
        }
        reviews{
          id
          url
          state
        }
    }`;
const $92d55c1fa1055bf9$var$getPullRequestQuery = (prName)=>`${prName} {
        id
        url
        name
        branchName
        branchUrl
        destinationBranchName
        destinationBranchUrl
        lastUpdate
        status
        author {
          name
          avatarUrl
        }
        reviewers{
          name
          avatarUrl
          isApproved
        }
        repositoryId
        repositoryName
        repositoryUrl
        repositoryAvatarUrl
    }`;
const $92d55c1fa1055bf9$var$buildProvidersQuery = `buildProviders {
          id
          name
          url
          description
          avatarUrl
          builds {
            id
            buildNumber
            name
            description
            url
            state
            testSummary {
              totalNumber
              numberPassed
              numberFailed
              numberSkipped
            }
            lastUpdated
            references {
              name
              uri
            }
          }
        }`;
const $92d55c1fa1055bf9$var$deploymentProvidersQuery = `deploymentProviders {
          id
          name
          homeUrl
          logoUrl
          deployments {
            displayName
            url
            state
            lastUpdated
            pipelineId
            pipelineDisplayName
            pipelineUrl
            environment {
                id
                type
                displayName
            }
          }
        }`;
const $92d55c1fa1055bf9$var$featureFlagsQuery = `featureFlagProviders {
        id
        createFlagTemplateUrl
        linkFlagTemplateUrl
        featureFlags {
            id
            key
            displayName
            providerId
            details{
                url
                lastUpdated
                environment{
                    name
                    type
                }
                status{
                enabled
                defaultValue
                rollout{
                    percentage
                    text
                    rules
                }
            }
        }
    }
}`;
const $92d55c1fa1055bf9$var$remoteLinksQuery = `remoteLinksByType {
        providers {
            id
            name
            homeUrl
            logoUrl
            documentationUrl
            actions {
                id
                label {
                    value
                }
                templateUrl
            }
        }
        types {
            type
            remoteLinks {
                id
                providerId
                displayName
                url
                type
                description
                status {
                    appearance
                    label
                }
                actionIds
                attributeMap {
                    key
                    value
                }
            }
        }
    }`;
const $92d55c1fa1055bf9$var$embeddedMarketplaceQuery = `
    embeddedMarketplace {
        shouldDisplayForBuilds,
        shouldDisplayForDeployments,
        shouldDisplayForFeatureFlags
      }
`;
// TYPO FIX: FUSE-8114 repository needs to be repositories
// TODO: FUSE-8114 buildProviders will be moved out of instanceTypes and placed under details
const $92d55c1fa1055bf9$var$innerQuery = ()=>`
    details {
        instanceTypes {
            id
            name
            type
            typeName
            isSingleInstance
            baseUrl
            devStatusErrorMessages
            repository {
                id
                name
                avatarUrl
                description
                url
                parent {
                    name
                    url
                }
                ${$92d55c1fa1055bf9$var$branchesQuery}
                ${$92d55c1fa1055bf9$var$commitsQuery}
                ${$92d55c1fa1055bf9$var$getPullRequestQuery('pullRequests')}
            }
            ${$92d55c1fa1055bf9$var$getPullRequestQuery('danglingPullRequests')}
            ${$92d55c1fa1055bf9$var$buildProvidersQuery}
         }
         ${$92d55c1fa1055bf9$var$deploymentProvidersQuery}
         ${$92d55c1fa1055bf9$var$featureFlagsQuery}
         ${$92d55c1fa1055bf9$var$remoteLinksQuery}
         ${$92d55c1fa1055bf9$var$embeddedMarketplaceQuery}
    }
`;
const $92d55c1fa1055bf9$var$swagGraphQLQuery = ()=>`
    query ${$92d55c1fa1055bf9$var$OPERATION_NAME} ($issueId: ID!) {
        developmentInformation(issueId: $issueId){
            ${$92d55c1fa1055bf9$var$innerQuery()}
        }
    }`;
const $92d55c1fa1055bf9$var$query = (baseUrl, issueId)=>// @ts-expect-error - TS2322 - Type 'Promise<ResponseData | { data: unknown; }>' is not assignable to type 'Promise<ResponseData>'.
    (0, $cBLvH.query$)(baseUrl, $92d55c1fa1055bf9$var$OPERATION_NAME, $92d55c1fa1055bf9$var$swagGraphQLQuery(), {
        issueId: issueId
    }).toPromise().then((result)=>({
            data: result
        }));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$92d55c1fa1055bf9$export$2e2bcd8739ae039 = (baseUrl, issueId)=>$92d55c1fa1055bf9$var$query(baseUrl, issueId);

});
parcelRegister("cBLvH", function(module, exports) {

$parcel$export(module.exports, "query$", () => $b2e62d4903324e0d$export$a332dd84c3221bf2);

var $4nUsC = parcelRequire("4nUsC");
const $b2e62d4903324e0d$export$a332dd84c3221bf2 = (baseUrl, operationName, query, variables, analyticOptions)=>(0, $4nUsC.operation$)('query', baseUrl, operationName, query, variables, analyticOptions);

});
parcelRegister("4nUsC", function(module, exports) {

$parcel$export(module.exports, "operation$", () => $9d6dd91dc35e6aa9$export$cbc7c612df05bda);
parcelRequire("fp4O3");
parcelRequire("3q49N");
parcelRequire("inj9P");
parcelRequire("64ZAE");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $9XE6b = parcelRequire("9XE6b");

var $aZFhV = parcelRequire("aZFhV");

var $kVLXA = parcelRequire("kVLXA");

var $7Jxgt = parcelRequire("7Jxgt");

var $dGrdR = parcelRequire("dGrdR");

var $2YZCu = parcelRequire("2YZCu");

var $kobfu = parcelRequire("kobfu");

var $487fd = parcelRequire("487fd");

var $fnyT4 = parcelRequire("fnyT4");

var $4tcSU = parcelRequire("4tcSU");

var $fjcgS = parcelRequire("fjcgS");

var $cNrxd = parcelRequire("cNrxd");

var $04zaL = parcelRequire("04zaL");
const $9d6dd91dc35e6aa9$var$sendOperationalEvent = (analyticKey, statusCode)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        // SSR doesn't have an analytics client
        if (!analyticsClient) return;
        let statusCodeFamily = 'unknown';
        if (statusCode !== null) {
            const statusCodeAsStr = String(statusCode);
            if (statusCodeAsStr === '0' || statusCodeAsStr === '429') // special status codes
            statusCodeFamily = statusCodeAsStr;
            else if (statusCodeAsStr.match(/^[12345][0-9]{2}$/)) statusCodeFamily = `${statusCodeAsStr[0]}xx`;
        }
        analyticsClient.sendOperationalEvent({
            action: 'fetch',
            actionSubject: 'swag operation',
            attributes: {
                key: analyticKey,
                statusCode: statusCode,
                statusCodeFamily: statusCodeFamily
            },
            source: 'swagOperation'
        });
    });
};
const $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark = (analyticKey, slo, statusCode, concurrentId, // eslint-disable-next-line @typescript-eslint/no-explicit-any
bm3Interaction)=>{
    if (analyticKey !== undefined) {
        // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        $9d6dd91dc35e6aa9$var$sendOperationalEvent(analyticKey, statusCode);
        if (bm3Interaction) bm3Interaction.cancel();
    }
};
const $9d6dd91dc35e6aa9$var$callSwag$ = ({ baseUrl: baseUrl, operationName: operationName, query: query, variables: variables, action: action, headersProcessor: headersProcessor })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let headers = {};
    // set empty xsrfToken for SSR as cookies are unavailable
    const xsrfToken = false ? '' : (0, $4tcSU.default)();
    if (action === 'mutation') {
        if (!xsrfToken) (0, $2YZCu.default).safeErrorWithoutCustomerData('board.xsrf-token.load.failure', 'XSRF Token failed to load');
        headers = {
            'atl-xsrf-token': xsrfToken
        };
    }
    return (0, $487fd.default)(`${baseUrl}/jsw2/graphql?operation=${operationName}`, {
        method: 'POST',
        body: JSON.stringify({
            operationName: operationName,
            query: query,
            variables: variables
        }),
        headers: headers,
        headersProcessor: headersProcessor
    });
};
const $9d6dd91dc35e6aa9$export$cbc7c612df05bda = (action, baseUrl, operationName, query, variables, analyticOptions)=>{
    const { analyticKey: analyticKey, slo: slo, useBm3Interaction: useBm3Interaction, concurrentMetricDefinition: concurrentMetricDefinition } = analyticOptions || {};
    let traceId = '';
    const headersProcessor = (headers)=>{
        traceId = headers.get((0, $fnyT4.TRACE_ID_HEADER)) || '';
    };
    const concurrentId = (0, $7Jxgt.v4)();
    let bm3Interaction = null;
    if (analyticKey && useBm3Interaction) bm3Interaction = (0, $dGrdR.metrics).interaction({
        key: analyticKey,
        // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
        histogram: {
            result: '1000_2000_3000_4000_5000_6000'
        }
    });
    return (0, $kVLXA.Observable).defer(()=>{
        if (bm3Interaction) bm3Interaction.start();
        if (concurrentMetricDefinition !== undefined) concurrentMetricDefinition(concurrentId).start();
        return $9d6dd91dc35e6aa9$var$callSwag$({
            baseUrl: baseUrl,
            operationName: operationName,
            query: query,
            variables: variables,
            action: action,
            headersProcessor: headersProcessor
        });
    }).catch((error)=>{
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'statusCode'
        ], null);
        const isRetryStatusCode = [
            502,
            503,
            504
        ].includes(Number(statusCode));
        if (isRetryStatusCode && action === 'query') return $9d6dd91dc35e6aa9$var$callSwag$({
            baseUrl: baseUrl,
            operationName: operationName,
            query: query,
            variables: variables,
            action: action,
            headersProcessor: headersProcessor
        }).do(()=>{
            (0, $04zaL.logRestRetry)({
                queryName: operationName,
                statusCode: statusCode,
                isRetrySuccessful: true,
                retryStatusCode: null
            });
        }, (retryError)=>{
            const retryStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(retryError, [
                'statusCode'
            ], null);
            (0, $04zaL.logRestRetry)({
                queryName: operationName,
                statusCode: statusCode,
                isRetrySuccessful: false,
                retryStatusCode: retryStatusCode
            });
        });
        // throw exception to the next level
        return (0, $kVLXA.Observable).throw(error);
    })// catch network error
    .catch((error)=>{
        const e = (0, (/*@__PURE__*/$parcel$interopDefault($aZFhV)))(error) ? error.message : `[unknown error] = ${JSON.stringify(error)}`;
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'statusCode'
        ], null);
        const errorName = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'name'
        ], null);
        const swagError = new (0, $cNrxd.SwagError)({
            networkError: error,
            traceId: traceId
        });
        const hash = (0, $kobfu.getErrorHash)(swagError);
        (0, $04zaL.logRestNetworkError)(e, statusCode, operationName, errorName, hash);
        $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, statusCode, concurrentId, bm3Interaction);
        return (0, $kVLXA.Observable).throw(swagError);
    }).flatMap((response)=>{
        if (!response || !response.data) (0, $04zaL.logRestParsingError)('empty response.data', operationName);
        try {
            // SWAG errors from response
            if (response.errors) {
                if (response.errors.length > 100) {
                    const genericMessage = `Too many Errors in response for ${operationName}`;
                    (0, $04zaL.logRestError)([
                        genericMessage
                    ], null, operationName, 'too-many-errors');
                    $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, null, concurrentId, bm3Interaction);
                    return (0, $kVLXA.Observable).throw(new (0, $cNrxd.SwagError)({
                        graphQLErrors: [
                            {
                                message: genericMessage,
                                path: [
                                    genericMessage
                                ],
                                extensions: {
                                    statusCode: null,
                                    errorType: 'too-many-errors'
                                }
                            }
                        ],
                        traceId: traceId
                    }));
                }
                const payload = response.errors.map((e)=>{
                    const { path: path, message: message } = e;
                    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
                        'extensions',
                        'statusCode'
                    ], null);
                    const errorType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
                        'extensions',
                        'errorType'
                    ], undefined);
                    const userMessage = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
                        'extensions',
                        'userMessage'
                    ], undefined);
                    (0, $04zaL.logRestError)(path, statusCode, operationName, errorType);
                    $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, statusCode, concurrentId, bm3Interaction);
                    return {
                        message: message,
                        path: path,
                        extensions: {
                            statusCode: statusCode ? Number(statusCode) : null,
                            errorType: errorType,
                            userMessage: userMessage
                        }
                    };
                });
                return (0, $kVLXA.Observable).throw(new (0, $cNrxd.SwagError)({
                    graphQLErrors: payload,
                    traceId: traceId
                }));
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const e = (0, (/*@__PURE__*/$parcel$interopDefault($aZFhV)))(error) ? error.message : `[unknown error] = ${JSON.stringify(error)}`;
            (0, $04zaL.logRestParsingError)(e, operationName);
            $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, 'unknown', concurrentId, bm3Interaction);
            throw error;
        }
        if (analyticKey !== undefined) {
            // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Response<Data>'.
            $9d6dd91dc35e6aa9$var$sendOperationalEvent(analyticKey, response.statusCode ?? '200');
            if (bm3Interaction) bm3Interaction.stop();
            if (concurrentMetricDefinition !== undefined) concurrentMetricDefinition(concurrentId).stop();
        }
        return (0, $kVLXA.Observable).of(response.data);
    });
};

});
parcelRegister("487fd", function(module, exports) {

$parcel$export(module.exports, "default", () => $96196282ac54fa24$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("1oQta");
parcelRequire("d0pqD");
parcelRequire("fPS7b");

var $x9xyg = parcelRequire("x9xyg");

var $5HnTq = parcelRequire("5HnTq");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $96196282ac54fa24$var$noContentStatus = 204;
const $96196282ac54fa24$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $96196282ac54fa24$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$96196282ac54fa24$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $x9xyg.setMark)(`BEGIN_${key}`);
    }
    return (0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $5HnTq.defaultOptions), opts), (0, $51xpa.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $x9xyg.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, str, traceId);
                else throw new (0, $jJZqs.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $96196282ac54fa24$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        return response.json();
    });
}
var $96196282ac54fa24$export$2e2bcd8739ae039 = $96196282ac54fa24$var$fetchJson$;

});

parcelRegister("cNrxd", function(module, exports) {

$parcel$export(module.exports, "SwagError", () => $116bdf44a4142aa3$export$c6b77322a15ada4f);
$parcel$export(module.exports, "isJson", () => $116bdf44a4142aa3$export$952e1d8683e4d0c4);
$parcel$export(module.exports, "isFetchError", () => $116bdf44a4142aa3$export$96f7e6db4105d70c);
$parcel$export(module.exports, "isSwagError", () => $116bdf44a4142aa3$export$7d7253f3a1a7c031);

var $jJZqs = parcelRequire("jJZqs");
const $116bdf44a4142aa3$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if (Array.isArray(err.graphQLErrors) && err.graphQLErrors.length !== 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `GraphQL error: ${errorMessage}\n`;
    });
    if (err.networkError) message += `Network error: ${err.networkError.message}\n`;
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $116bdf44a4142aa3$export$c6b77322a15ada4f extends Error {
    constructor({ graphQLErrors: graphQLErrors, networkError: networkError, errorMessage: errorMessage, traceId: traceId = '' }){
        super(errorMessage), this.graphQLErrors = [], this.networkError = null, // SWAG trace id, extracted from "atl-traceid" response-header
        // Helps to find relevant error in SWAG logs
        this.traceId = '';
        this.graphQLErrors = graphQLErrors || [];
        this.networkError = networkError || null;
        if (!errorMessage) this.message = $116bdf44a4142aa3$var$generateErrorMessage(this);
        else this.message = errorMessage;
        this.name = this.constructor.name;
        this.traceId = traceId;
        this.cause = networkError || graphQLErrors?.[0];
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(this.message).stack;
    }
    skipSentry() {
        return this.networkError != null || this.graphQLErrors.length > 0;
    }
}
const $116bdf44a4142aa3$export$952e1d8683e4d0c4 = (value)=>{
    try {
        JSON.parse(value);
    } catch (e) {
        return false;
    }
    return true;
};
const $116bdf44a4142aa3$export$96f7e6db4105d70c = (error)=>error !== null && typeof error === 'object' && error instanceof (0, $jJZqs.default);
const $116bdf44a4142aa3$export$7d7253f3a1a7c031 = (error)=>{
    if (error !== null && typeof error === 'object' && error instanceof $116bdf44a4142aa3$export$c6b77322a15ada4f) return 'graphQLErrors' in error || 'networkError' in error;
    return false;
};

});

parcelRegister("04zaL", function(module, exports) {

$parcel$export(module.exports, "logApolloError", () => $1590485f1b901936$export$2c9c775c9aa1863d);
$parcel$export(module.exports, "logApolloNetworkError", () => $1590485f1b901936$export$45c096492076b53a);
$parcel$export(module.exports, "logRestError", () => $1590485f1b901936$export$9a40393cdc64dc7d);
$parcel$export(module.exports, "logRestNetworkError", () => $1590485f1b901936$export$b2eb9fe68368f77d);
$parcel$export(module.exports, "logRestParsingError", () => $1590485f1b901936$export$25d52be9f4671e9e);
$parcel$export(module.exports, "logRestRetry", () => $1590485f1b901936$export$e8ce08d55ac713ef);
$parcel$export(module.exports, "logApolloRetry", () => $1590485f1b901936$export$3e50530825dee9d1);

var $2YZCu = parcelRequire("2YZCu");
const $1590485f1b901936$var$logError = (type, m, extra)=>{
    const { message: message, path: path, queryName: queryName, statusCode: statusCode, errorType: errorType, errorName: errorName, hash: hash } = extra;
    const params = {
        message: message || '',
        path: JSON.stringify(path || []),
        statusCode: String(statusCode || '[unknown]'),
        queryName: queryName,
        errorType: errorType ? String(errorType) : '',
        errorName: errorName ? String(errorName) : '',
        hash: hash
    };
    return (0, $2YZCu.default).safeErrorWithoutCustomerData(type, m, params);
};
const $1590485f1b901936$var$SwagErrorPlaceholder = '[errors in SWAG response]';
const $1590485f1b901936$export$2c9c775c9aa1863d = (path, statusCode, queryName, errorType)=>$1590485f1b901936$var$logError('apollo.swag.error.graphql', '[GraphQL error]', {
        message: $1590485f1b901936$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
const $1590485f1b901936$export$45c096492076b53a = (networkError, statusCode, queryName)=>{
    $1590485f1b901936$var$logError('apollo.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName
    });
};
const $1590485f1b901936$export$9a40393cdc64dc7d = (path, statusCode, queryName, errorType)=>{
    $1590485f1b901936$var$logError('rest.swag.error.graphql', '[GraphQL error]', {
        message: $1590485f1b901936$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
};
const $1590485f1b901936$export$b2eb9fe68368f77d = (networkError, statusCode, queryName, errorName, hash)=>{
    $1590485f1b901936$var$logError('rest.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName,
        errorName: errorName,
        hash: hash
    });
};
const $1590485f1b901936$export$25d52be9f4671e9e = (error, queryName)=>{
    $1590485f1b901936$var$logError('rest.swag.error.parsing', '[Parsing error]', {
        message: `[Parsing error]: ${error}`,
        queryName: queryName
    });
};
const $1590485f1b901936$export$e8ce08d55ac713ef = ({ queryName: queryName, statusCode: statusCode, isRetrySuccessful: isRetrySuccessful, retryStatusCode: retryStatusCode })=>(0, $2YZCu.default).safeErrorWithoutCustomerData('rest.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode || '',
        isRetrySuccessful: String(isRetrySuccessful),
        retryStatusCode: retryStatusCode || ''
    });
const $1590485f1b901936$export$3e50530825dee9d1 = ({ queryName: queryName, statusCode: statusCode })=>(0, $2YZCu.default).safeErrorWithoutCustomerData('apollo.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode
    });

});




parcelRegister("iGw8p", function(module, exports) {

$parcel$export(module.exports, "transformFeatureFlags", () => $b03a1c094f33400f$export$713c7344ce0fdc3b);

var $chc6P = parcelRequire("chc6P");

var $fn8B5 = parcelRequire("fn8B5");

var $dX67e = parcelRequire("dX67e");
const $b03a1c094f33400f$var$ENVIRONMENT_TYPE_OTHER = 'other';
const $b03a1c094f33400f$var$flattenFeatureFlag = (featureFlag)=>(0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(featureFlag.details, (ffDetails)=>({
            id: featureFlag.id,
            key: featureFlag.key,
            displayName: featureFlag.displayName,
            providerId: featureFlag.providerId,
            ...ffDetails
        }));
const $b03a1c094f33400f$var$flattenFeatureFlags = (provider)=>provider.featureFlags ? (0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(provider.featureFlags, (ff)=>$b03a1c094f33400f$var$flattenFeatureFlag(ff)) : [];
const $b03a1c094f33400f$var$getEnvironmentType = ({ type: type })=>// @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type '"other" | "production" | "staging" | "development" | "testing"'.
    (0, $dX67e.featureFlagEnvironmentTypes).includes(type) ? type : $b03a1c094f33400f$var$ENVIRONMENT_TYPE_OTHER;
const $b03a1c094f33400f$var$transformEnvironment = (environment)=>({
        ...environment,
        type: $b03a1c094f33400f$var$getEnvironmentType(environment)
    });
const $b03a1c094f33400f$var$transformFlag = (flag)=>({
        // @ts-expect-error - TS2783 - 'id' is specified more than once, so this usage will be overwritten.
        id: flag.id,
        // @ts-expect-error - TS2783 - 'providerId' is specified more than once, so this usage will be overwritten.
        providerId: flag.providerId,
        key: flag.key,
        // @ts-expect-error - TS2783 - 'displayName' is specified more than once, so this usage will be overwritten.
        displayName: flag.displayName,
        ...flag,
        environment: $b03a1c094f33400f$var$transformEnvironment(flag.environment)
    });
// @ts-expect-error - TS2304 - Cannot find name 'FeatureFlagProvider'.
const $b03a1c094f33400f$var$transformProviders = (providers)=>{
    const flatFlags = (0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(providers, (provider)=>(0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))($b03a1c094f33400f$var$flattenFeatureFlags(provider), (flatFlag)=>({
                // @ts-expect-error - TS2783 - 'providerId' is specified more than once, so this usage will be overwritten.
                providerId: provider.id,
                ...$b03a1c094f33400f$var$transformFlag(flatFlag)
            })));
    return (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(flatFlags, ({ environment: environment })=>$b03a1c094f33400f$var$getEnvironmentType(environment));
};
const $b03a1c094f33400f$export$713c7344ce0fdc3b = (featureFlagProviders)=>$b03a1c094f33400f$var$transformProviders(featureFlagProviders);

});
parcelRegister("dX67e", function(module, exports) {

$parcel$export(module.exports, "featureFlagEnvironmentTypes", () => $77da9ca49ce4b771$export$8a335de8ae8d5712);
const $77da9ca49ce4b771$var$ENVIRONMENT_TYPE_PRODUCTION = 'production';
const $77da9ca49ce4b771$var$ENVIRONMENT_TYPE_STAGING = 'staging';
const $77da9ca49ce4b771$var$ENVIRONMENT_TYPE_TESTING = 'testing';
const $77da9ca49ce4b771$var$ENVIRONMENT_TYPE_DEVELOPMENT = 'development';
const $77da9ca49ce4b771$var$ENVIRONMENT_TYPE_OTHER = 'other';
const $77da9ca49ce4b771$export$8a335de8ae8d5712 = [
    $77da9ca49ce4b771$var$ENVIRONMENT_TYPE_PRODUCTION,
    $77da9ca49ce4b771$var$ENVIRONMENT_TYPE_STAGING,
    $77da9ca49ce4b771$var$ENVIRONMENT_TYPE_TESTING,
    $77da9ca49ce4b771$var$ENVIRONMENT_TYPE_DEVELOPMENT,
    $77da9ca49ce4b771$var$ENVIRONMENT_TYPE_OTHER
];

});


parcelRegister("6Q8ez", function(module, exports) {

$parcel$export(module.exports, "transformRemoteLinks", () => $7c7fd102a6f9108c$export$c070e22f287b7fc7);

var $3daP9 = parcelRequire("3daP9");
const $7c7fd102a6f9108c$export$53b6bdd225fa8b4b = (providerId, remoteLinkProvider)=>({
        id: providerId,
        name: remoteLinkProvider.name,
        homeUrl: remoteLinkProvider.homeUrl,
        logoUrl: remoteLinkProvider.logoUrl ? remoteLinkProvider.logoUrl : null,
        documentationUrl: remoteLinkProvider.documentationUrl ? remoteLinkProvider.documentationUrl : null
    });
const $7c7fd102a6f9108c$export$a97844e947d8eadf = (remoteLinkProvider, actionIds, attributeMap)=>{
    if (remoteLinkProvider.actions && actionIds) {
        const remoteLinkProviderActions = remoteLinkProvider.actions;
        return actionIds// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly id: { label: RemoteLinkLabel; templateUrl: string; }; }'.
        .filter((actionId)=>remoteLinkProviderActions[actionId]).map((actionId)=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly id: { label: RemoteLinkLabel; templateUrl: string; }; }'.
            const baseUrl = remoteLinkProviderActions[actionId].templateUrl;
            return {
                id: actionId,
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly id: { label: RemoteLinkLabel; templateUrl: string; }; }'.
                label: remoteLinkProviderActions[actionId].label.value,
                url: attributeMap ? attributeMap.reduce((resultUrl, substitution)=>resultUrl.replace(`{${substitution.key}}`, substitution.value), baseUrl) : baseUrl
            };
        });
    }
    return [];
};
const $7c7fd102a6f9108c$export$323a7fe46ef8c5af = (providers)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    providers.reduce((result, provider)=>{
        const { id: id, actions: actions, ...restOfProvider } = provider;
        result[id] = {
            ...restOfProvider,
            ...actions && {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                actions: actions.reduce((actionResult, action)=>{
                    const { id: actionId, ...restOfAction } = action;
                    actionResult[actionId] = restOfAction;
                    return actionResult;
                }, {})
            }
        };
        return result;
    }, {});
const $7c7fd102a6f9108c$export$c070e22f287b7fc7 = (remoteLinksByType)=>{
    const remoteLinkProviders = remoteLinksByType.providers.filter((provider)=>!(0, $3daP9.isVersionRelatedLinksProvider)(provider.id));
    const modifiedProviders = $7c7fd102a6f9108c$export$323a7fe46ef8c5af(remoteLinkProviders);
    const remoteLinkTypes = remoteLinksByType.types.filter((type)=>{
        const filteredLinks = type.remoteLinks.filter((link)=>!(0, $3daP9.isVersionRelatedLinksProvider)(link.providerId));
        return filteredLinks.length > 0;
    });
    return remoteLinkTypes.reduce((result, element)=>{
        const { type: type, remoteLinks: remoteLinks } = element;
        const links = remoteLinks.filter((link)=>!(0, $3daP9.isVersionRelatedLinksProvider)(link.providerId));
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        result.remoteLinksByType[type] = links.map((remoteLink)=>{
            const { providerId: providerId, actionIds: actionIds, attributeMap: attributeMap, description: description, status: status, ...restOfRemoteLink } = remoteLink;
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RemoteLinkProviderTransformed'.
            const remoteLinkProvider = modifiedProviders[providerId];
            if (!remoteLinkProvider) return {};
            return {
                provider: $7c7fd102a6f9108c$export$53b6bdd225fa8b4b(providerId, remoteLinkProvider),
                description: description || null,
                status: status || null,
                ...restOfRemoteLink,
                actions: $7c7fd102a6f9108c$export$a97844e947d8eadf(remoteLinkProvider, actionIds, attributeMap)
            };
        }).filter((remoteLink)=>Object.keys(remoteLink).length !== 0);
        return result;
    }, {
        numProviders: remoteLinkProviders.length,
        remoteLinksByType: {}
    });
};

});
parcelRegister("3daP9", function(module, exports) {

$parcel$export(module.exports, "isVersionRelatedLinksProvider", () => $138f1032e92a6daa$export$d85eb3fb354ab222);

const $138f1032e92a6daa$export$d85eb3fb354ab222 = (id)=>id === (0, $ed461637e46aec23$export$a42a1a2fb6310bc7) || id === (0, $ed461637e46aec23$export$e68cad5334cc5b);

});



parcelRegister("9hfbX", function(module, exports) {

$parcel$export(module.exports, "getOptOutDeploymentsDiscovery", () => $84125d7f3a61fca9$export$feb9f7f82afe74b1);
$parcel$export(module.exports, "setOptOutDeploymentsDiscovery", () => $84125d7f3a61fca9$export$e5e1193be89a6ae4);

var $3vGA8 = parcelRequire("3vGA8");
const $84125d7f3a61fca9$var$OPT_OUT_DEPLOYMENTS_DISCOVERY = 'open-toolchain-opt-user-out-deployments-ddd-discovery';
const $84125d7f3a61fca9$export$feb9f7f82afe74b1 = (accountId)=>(0, $3vGA8.getUserProperty)({
        accountId: accountId,
        propertyKey: $84125d7f3a61fca9$var$OPT_OUT_DEPLOYMENTS_DISCOVERY,
        defaultValue: false
    }).then((property)=>property.value);
const $84125d7f3a61fca9$export$e5e1193be89a6ae4 = (accountId)=>(0, $3vGA8.setUserProperty)({
        accountId: accountId,
        propertyValue: true,
        propertyKey: $84125d7f3a61fca9$var$OPT_OUT_DEPLOYMENTS_DISCOVERY
    });

});
parcelRegister("3vGA8", function(module, exports) {

$parcel$export(module.exports, "setUserProperty", () => $2c0ca5ac70f11dac$export$ba821ce5e177c7ef);
$parcel$export(module.exports, "getUserProperty", () => $2c0ca5ac70f11dac$export$b3126db2ef6e34ed);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $2c0ca5ac70f11dac$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $2c0ca5ac70f11dac$var$handleErrorLogging = (operation, error, attributes)=>{
    (0, $jcw0u.default)({
        meta: {
            id: operation,
            packageName: 'jiraDevelopmentDetails',
            teamName: 'nova'
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        attributes: attributes
    });
};
const $2c0ca5ac70f11dac$export$ba821ce5e177c7ef = async ({ propertyValue: propertyValue, propertyKey: propertyKey, accountId: accountId })=>{
    const url = $2c0ca5ac70f11dac$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $eusud.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        $2c0ca5ac70f11dac$var$handleErrorLogging('setUserProperty', error, {
            propertyValue: JSON.stringify(propertyValue)
        });
        throw error;
    }
};
const $2c0ca5ac70f11dac$export$b3126db2ef6e34ed = async ({ propertyKey: propertyKey, defaultValue: defaultValue, accountId: accountId })=>{
    const url = $2c0ca5ac70f11dac$var$getUserUrl(accountId, propertyKey);
    try {
        const response = await (0, $eusud.performGetRequest)(url);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};

});


parcelRegister("8Fofq", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $e89c8b048e5f542a$export$f654b28f82155665);
$parcel$export(module.exports, "getIssueId", () => $e89c8b048e5f542a$export$b4dd560abafd1fae);
$parcel$export(module.exports, "getIssueKey", () => $e89c8b048e5f542a$export$4a030f6192bebe03);
$parcel$export(module.exports, "getLocale", () => $e89c8b048e5f542a$export$180605366c04f0cd);
$parcel$export(module.exports, "getSelectedTab", () => $e89c8b048e5f542a$export$76c530fbe2143c48);
$parcel$export(module.exports, "getProjectAri", () => $e89c8b048e5f542a$export$1029c05cae8fb823);
$parcel$export(module.exports, "getAccountId", () => $e89c8b048e5f542a$export$c1e0336bde96e2dc);
const $e89c8b048e5f542a$var$getApp = (state)=>state.app;
const $e89c8b048e5f542a$export$f654b28f82155665 = (state)=>$e89c8b048e5f542a$var$getApp(state).baseUrl;
const $e89c8b048e5f542a$export$b4dd560abafd1fae = (state)=>$e89c8b048e5f542a$var$getApp(state).issueId;
const $e89c8b048e5f542a$export$4a030f6192bebe03 = (state)=>$e89c8b048e5f542a$var$getApp(state).issueKey;
const $e89c8b048e5f542a$export$180605366c04f0cd = (state)=>$e89c8b048e5f542a$var$getApp(state).locale;
const $e89c8b048e5f542a$export$76c530fbe2143c48 = (state)=>$e89c8b048e5f542a$var$getApp(state).selectedTab;
const $e89c8b048e5f542a$export$1029c05cae8fb823 = (state)=>$e89c8b048e5f542a$var$getApp(state).projectAri;
const $e89c8b048e5f542a$export$c1e0336bde96e2dc = (state)=>$e89c8b048e5f542a$var$getApp(state).accountId;

});


parcelRegister("9P9CS", function(module, exports) {

$parcel$export(module.exports, "epic", () => $6358fb3c0276568d$export$8ec5145af6f76965);
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $7qcff = parcelRequire("7qcff");

var $kw5c5 = parcelRequire("kw5c5");

var $hBYWk = parcelRequire("hBYWk");

var $8Fofq = parcelRequire("8Fofq");
const $6358fb3c0276568d$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $7qcff.INITIALIZE_APP_PROPS)).mergeMap(()=>{
        const state = store.getState();
        const selectedTab = (0, $8Fofq.getSelectedTab)(state);
        // @ts-expect-error - TS2769 - No overload matches this call.
        return (0, $kVLXA.Observable).of((0, $kw5c5.fetchDetail)(), (0, $hBYWk.changeTab)(selectedTab));
    });

});
parcelRegister("7qcff", function(module, exports) {

$parcel$export(module.exports, "INITIALIZE_APP_PROPS", () => $afeb9f7e78066100$export$84856e4ae7cd7538);
$parcel$export(module.exports, "initializeAppProps", () => $afeb9f7e78066100$export$5f0e35553cecddfe);
const $afeb9f7e78066100$export$84856e4ae7cd7538 = 'state.actions.app.INITIALIZE_APP_PROPS';
const $afeb9f7e78066100$export$5f0e35553cecddfe = (payload)=>({
        type: $afeb9f7e78066100$export$84856e4ae7cd7538,
        payload: payload
    });

});



parcelRegister("3Q7M9", function(module, exports) {

$parcel$export(module.exports, "default", () => $97d56bdc08d8de4f$export$2e2bcd8739ae039);

var $F2Mxm = parcelRequire("F2Mxm");

var $g3qyq = parcelRequire("g3qyq");


var $62pQV = parcelRequire("62pQV");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$97d56bdc08d8de4f$export$2e2bcd8739ae039 = (rootEpic)=>(0, $F2Mxm.default)({
        appName: 'development/details',
        rootReducer: $62pQV.default,
        rootEpic: rootEpic,
        middlewares: [
            (0, $g3qyq.default)((0, $ed461637e46aec23$export$d76071d5de2774fc))
        ]
    });

});
parcelRegister("g3qyq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c091411acc86b19$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $aMh57 = parcelRequire("aMh57");
/**
 * Catches errors within redux reducers and makes them available to monitoring.
 *
 * Takes an optional error action creator as a parameter to be reduced when an error is encountered.
 * This could be used to show an error flag, for example.
 *
 * Should be passed as part of the middleware array when creating the store.
 * E.g. [middlewareOne, errorHandling('your-app-name')]
 */ const $4c091411acc86b19$var$errorHandling = (appId, errorActionCreator, /**
		 * Callback for errors
		 */ onError)=>()=>(next)=>(action)=>{
                try {
                    next(action);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    const fullLocation = `common.redux-error.${appId}`;
                    (0, $2YZCu.default).safeErrorWithoutCustomerData(fullLocation, `Unhandled error for Redux action: '${action?.type}'`, error);
                    (0, $aMh57.captureException)(fullLocation, error);
                    errorActionCreator && next(errorActionCreator());
                    onError && onError(error);
                }
            };
var $4c091411acc86b19$export$2e2bcd8739ae039 = $4c091411acc86b19$var$errorHandling;

});

parcelRegister("62pQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f12eb9e4dec7785c$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $9CWcs = parcelRequire("9CWcs");

var $ezAD2 = parcelRequire("ezAD2");

var $6Izp5 = parcelRequire("6Izp5");
var $f12eb9e4dec7785c$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    app: $9CWcs.default,
    ui: $6Izp5.default,
    details: $ezAD2.default
});

});
parcelRegister("9CWcs", function(module, exports) {

$parcel$export(module.exports, "default", () => $24291ed64a2dd9c7$export$2e2bcd8739ae039);

var $21iV6 = parcelRequire("21iV6");


var $7qcff = parcelRequire("7qcff");
const $24291ed64a2dd9c7$export$49d5fc8cba920a0 = {
    baseUrl: '',
    issueId: '',
    issueKey: '',
    locale: (0, $21iV6.defaultLocale),
    selectedTab: (0, $61a2cd6236d50c20$export$e18d81f044132a0e),
    showRemoteLinks: false,
    projectAri: '',
    accountId: ''
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$24291ed64a2dd9c7$export$2e2bcd8739ae039 = (state = $24291ed64a2dd9c7$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $7qcff.INITIALIZE_APP_PROPS:
            return {
                ...state,
                ...action.payload
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("ezAD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $60b0596f3424a0dc$export$2e2bcd8739ae039);

var $kw5c5 = parcelRequire("kw5c5");
const $60b0596f3424a0dc$export$49d5fc8cba920a0 = {
    isLoading: false,
    isError: false,
    isDiffstatAnalyticsFired: false,
    details: {
        instanceTypeDetails: [],
        deploymentProviders: [],
        embeddedMarketplaceDetails: {
            shouldDisplayForBuilds: false,
            shouldDisplayForDeployments: false,
            shouldDisplayForFeatureFlags: false
        }
    },
    isOptOutOfDeploymentDiscovery: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$60b0596f3424a0dc$export$2e2bcd8739ae039 = (state = $60b0596f3424a0dc$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $kw5c5.FETCH_DETAIL:
            return {
                ...state,
                isLoading: true,
                isError: false
            };
        case 0, $kw5c5.FIRE_BITBUCKET_DIFFSTAT_ANALYTICS_EVENT:
            return {
                ...state,
                isDiffstatAnalyticsFired: true
            };
        case 0, $kw5c5.SET_DETAIL_DATA:
            return {
                ...state,
                isLoading: false,
                isError: false,
                details: action.payload.details,
                isOptOutOfDeploymentDiscovery: action.payload.isOptOutOfDeploymentDiscovery
            };
        case 0, $kw5c5.FETCHING_FAILED:
            return {
                ...state,
                isLoading: false,
                isError: true
            };
        case 0, $kw5c5.OPT_OUT_DEPLOYMENTS_DISCOVERY:
            return {
                ...state,
                isOptOutOfDeploymentDiscovery: true
            };
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            action;
            return state;
    }
};

});

parcelRegister("6Izp5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1201d4631554493$export$2e2bcd8739ae039);


var $hBYWk = parcelRequire("hBYWk");
const $e1201d4631554493$export$49d5fc8cba920a0 = {
    activeTab: (0, $61a2cd6236d50c20$export$e18d81f044132a0e),
    selectedApplicationType: undefined,
    isCreatingPullRequestFromDiscovery: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e1201d4631554493$export$2e2bcd8739ae039 = (state = $e1201d4631554493$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $hBYWk.CHANGE_TAB:
            return {
                ...state,
                activeTab: action.payload.activeTab,
                isCreatingPullRequestFromDiscovery: false
            };
        case 0, $hBYWk.SET_SELECTED_APPLICATION_TYPE:
            return {
                ...state,
                selectedApplicationType: action.payload.selectedApplicationType,
                isCreatingPullRequestFromDiscovery: false
            };
        // @ts-expect-error - TS2678 - Type '"state.actions.ui.OPEN_PULL_REQUEST_CREATION_DISCOVERY"' is not comparable to type '"state.actions.ui.CHANGE_TAB" | "state.actions.ui.SET_SELECTED_APPLICATION_TYPE"'.
        case 0, $hBYWk.OPEN_PULL_REQUEST_CREATION_DISCOVERY:
            return {
                ...state,
                isCreatingPullRequestFromDiscovery: true
            };
        // @ts-expect-error - TS2678 - Type '"state.actions.ui.CLOSE_PULL_REQUEST_CREATION_DISCOVERY"' is not comparable to type '"state.actions.ui.CHANGE_TAB" | "state.actions.ui.SET_SELECTED_APPLICATION_TYPE"'.
        case 0, $hBYWk.CLOSE_PULL_REQUEST_CREATION_DISCOVERY:
            return {
                ...state,
                isCreatingPullRequestFromDiscovery: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});



parcelRegister("cguAt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5449201119fa8d73$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $c04PQ = parcelRequire("c04PQ");

var $bC2fB = parcelRequire("bC2fB");


var $hBYWk = parcelRequire("hBYWk");

var $77bcb = parcelRequire("77bcb");

var $CSK1u = parcelRequire("CSK1u");

var $iPGbA = parcelRequire("iPGbA");

var $c1Eoe = parcelRequire("c1Eoe");

var $84tTm = parcelRequire("84tTm");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $5449201119fa8d73$var$tabs = [
    {
        type: (0, $61a2cd6236d50c20$export$e18d81f044132a0e),
        messageDescriptor: (0, $c1Eoe.default).branchTabLabel,
        TabContent: (0, $iPGbA.Branches)
    },
    {
        type: (0, $61a2cd6236d50c20$export$2e42513c7764d5f3),
        messageDescriptor: (0, $c1Eoe.default).commitTabLabel,
        TabContent: (0, $iPGbA.Commits)
    },
    {
        type: (0, $61a2cd6236d50c20$export$6f74b53d652f13f3),
        messageDescriptor: (0, $c1Eoe.default).pullRequestsTabLabel,
        TabContent: (0, $iPGbA.PullRequests)
    }
];
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $5449201119fa8d73$var$buildDeploymentFeatureFlagTabs = [
    {
        type: (0, $61a2cd6236d50c20$export$74a388a09f2a004e),
        messageDescriptor: (0, $c1Eoe.default).buildTabLabel,
        TabContent: (0, $iPGbA.Builds)
    },
    {
        type: (0, $61a2cd6236d50c20$export$90cac6260ae9ced5),
        messageDescriptor: (0, $c1Eoe.default).deploymentsTabLabel,
        TabContent: (0, $iPGbA.Deployments)
    },
    {
        type: (0, $61a2cd6236d50c20$export$c69477f358d30f7e),
        messageDescriptor: (0, $c1Eoe.default).featureFlagsLabel,
        TabContent: (0, $iPGbA.FeatureFlags)
    }
];
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $5449201119fa8d73$var$remoteLinksTabs = [
    {
        type: (0, $61a2cd6236d50c20$export$56470bdd9cd798d0),
        messageDescriptor: (0, $c1Eoe.default).remoteLinksLabel,
        TabContent: (0, $iPGbA.RemoteLinks)
    }
];
const $5449201119fa8d73$var$getAvailableTabs = (showRemoteLinks)=>{
    let availableTabs = $5449201119fa8d73$var$tabs;
    if ((0, $c04PQ.isFedRamp)()) return availableTabs;
    availableTabs = [
        ...availableTabs,
        ...$5449201119fa8d73$var$buildDeploymentFeatureFlagTabs
    ];
    if (showRemoteLinks) availableTabs = [
        ...availableTabs,
        ...$5449201119fa8d73$var$remoteLinksTabs
    ];
    return availableTabs;
};
const $5449201119fa8d73$var$ConnectedDetails = (0, $bC2fB.connect)((state)=>({
        activeTab: (0, $CSK1u.getActiveTab)(state),
        isLoading: (0, $77bcb.isLoading)(state),
        isError: (0, $77bcb.isError)(state)
    }), {
    onChangeTab: (0, $hBYWk.changeTab)
})((0, $84tTm.default));
const $5449201119fa8d73$var$DevelopmentDetails = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5449201119fa8d73$var$ConnectedDetails, {
        ...props,
        tabs: $5449201119fa8d73$var$getAvailableTabs(props.showRemoteLinks),
        Header: (0, $iPGbA.DetailsHeader)
    });
const $5449201119fa8d73$export$efb2d5db5f0ac000 = $5449201119fa8d73$var$getAvailableTabs;
var $5449201119fa8d73$export$2e2bcd8739ae039 = $5449201119fa8d73$var$DevelopmentDetails;

});
parcelRegister("iPGbA", function(module, exports) {

$parcel$export(module.exports, "DetailsHeader", () => $7cbf8212e3086774$export$56e2352e63353d99);
$parcel$export(module.exports, "Branches", () => $7cbf8212e3086774$export$bec84148410bc670);
$parcel$export(module.exports, "Builds", () => $7cbf8212e3086774$export$5026e6aa86fecb8d);
$parcel$export(module.exports, "Commits", () => $7cbf8212e3086774$export$42f6c967f424d901);
$parcel$export(module.exports, "Deployments", () => $7cbf8212e3086774$export$1e0d13bd7c83bc57);
$parcel$export(module.exports, "PullRequests", () => $7cbf8212e3086774$export$5c25d45187ab05fe);
$parcel$export(module.exports, "FeatureFlags", () => $7cbf8212e3086774$export$ab28ab2e245553c7);
$parcel$export(module.exports, "RemoteLinks", () => $7cbf8212e3086774$export$cd0ba36797648943);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $1HweQ = parcelRequire("1HweQ");

var $7bpo8 = parcelRequire("7bpo8");

const $7cbf8212e3086774$var$loadAsyncComponent = async ()=>{
    const result = await (parcelRequire("gnscx"));
    return result;
};
// DetailsHeaders
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7cbf8212e3086774$var$LazyDetailsHeaderComponent = (0, $kxZPA.lazy)(()=>$7cbf8212e3086774$var$loadAsyncComponent().then((exportedModule)=>({
            default: exportedModule.Header
        })), {});
const $7cbf8212e3086774$export$56e2352e63353d99 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "details-header-component",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1HweQ.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7cbf8212e3086774$var$LazyDetailsHeaderComponent, props));
// Branches
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7cbf8212e3086774$var$LazyBranchesComponent = (0, $kxZPA.lazy)(()=>$7cbf8212e3086774$var$loadAsyncComponent().then((exportedModule)=>({
            default: exportedModule.Branches
        })), {});
const $7cbf8212e3086774$export$bec84148410bc670 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "branches-component",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7bpo8.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7cbf8212e3086774$var$LazyBranchesComponent, props));
// Build
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7cbf8212e3086774$var$LazyBuildsComponent = (0, $kxZPA.lazy)(()=>$7cbf8212e3086774$var$loadAsyncComponent().then((exportedModule)=>({
            default: exportedModule.Builds
        })), {});
const $7cbf8212e3086774$export$5026e6aa86fecb8d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "builds-component",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7bpo8.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7cbf8212e3086774$var$LazyBuildsComponent, props));
// Commits
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7cbf8212e3086774$var$LazyCommitsComponent = (0, $kxZPA.lazy)(()=>$7cbf8212e3086774$var$loadAsyncComponent().then((exportedModule)=>({
            default: exportedModule.Commits
        })), {});
const $7cbf8212e3086774$export$42f6c967f424d901 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "commits-component",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7bpo8.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7cbf8212e3086774$var$LazyCommitsComponent, props));
// Deployment
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7cbf8212e3086774$var$LazyDeploymentsComponent = (0, $kxZPA.lazy)(()=>$7cbf8212e3086774$var$loadAsyncComponent().then((exportedModule)=>({
            default: exportedModule.Deployments
        })), {});
const $7cbf8212e3086774$export$1e0d13bd7c83bc57 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "deployments-component",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7bpo8.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7cbf8212e3086774$var$LazyDeploymentsComponent, props));
// PullRequests
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7cbf8212e3086774$var$LazyPullRequestsComponent = (0, $kxZPA.lazy)(()=>$7cbf8212e3086774$var$loadAsyncComponent().then((exportedModule)=>({
            default: exportedModule.PullRequests
        })), {});
const $7cbf8212e3086774$export$5c25d45187ab05fe = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "pull-requests-component",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7bpo8.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7cbf8212e3086774$var$LazyPullRequestsComponent, props));
// FeatureFlags
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7cbf8212e3086774$var$LazyFeatureFlagsComponent = (0, $kxZPA.lazy)(()=>$7cbf8212e3086774$var$loadAsyncComponent().then((exportedModule)=>({
            default: exportedModule.FeatureFlags
        })), {});
const $7cbf8212e3086774$export$ab28ab2e245553c7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "feature-flags-component",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7bpo8.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7cbf8212e3086774$var$LazyFeatureFlagsComponent, props));
// RemoteLinks
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7cbf8212e3086774$var$LazyRemoteLinksComponent = (0, $kxZPA.lazy)(()=>$7cbf8212e3086774$var$loadAsyncComponent().then((exportedModule)=>({
            default: exportedModule.RemoteLinks
        })), {});
const $7cbf8212e3086774$export$cd0ba36797648943 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "remote-links-component",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7bpo8.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7cbf8212e3086774$var$LazyRemoteLinksComponent, props));

});
parcelRegister("1HweQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d332f0810d7d4568$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jgVsb = parcelRequire("jgVsb");
function $d332f0810d7d4568$export$55e5a03ad60fe281() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d332f0810d7d4568$var$DetailsHeaderPlaceholderContent, null));
}
var $d332f0810d7d4568$export$2e2bcd8739ae039 = $d332f0810d7d4568$export$55e5a03ad60fe281;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d332f0810d7d4568$var$DetailsHeaderPlaceholderContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i7ynd",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7bpo8", function(module, exports) {

$parcel$export(module.exports, "default", () => $760683cdf2d8b6ed$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVzqh = parcelRequire("fVzqh");

var $iYdGD = parcelRequire("iYdGD");
function $760683cdf2d8b6ed$export$c8c82333c05efb99() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iYdGD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVzqh.default), null));
}
var $760683cdf2d8b6ed$export$2e2bcd8739ae039 = $760683cdf2d8b6ed$export$c8c82333c05efb99;

});
parcelRegister("fVzqh", function(module, exports) {

$parcel$export(module.exports, "default", () => $5974c6ac06f90197$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5974c6ac06f90197$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5974c6ac06f90197$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5974c6ac06f90197$var$SpinnerAligner, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5974c6ac06f90197$var$SpinnerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1tkedgin _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $5974c6ac06f90197$var$SpinnerAligner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _94n5xy5q",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iYdGD", function(module, exports) {

$parcel$export(module.exports, "TruncateWrapper", () => $a7d8ed6b2ef3072d$export$42d4c92a873375eb);
$parcel$export(module.exports, "default", () => $a7d8ed6b2ef3072d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gwIPs = parcelRequire("gwIPs");
const $a7d8ed6b2ef3072d$export$42d4c92a873375eb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a7d8ed6b2ef3072d$var$TruncateContainer, null, children);
const $a7d8ed6b2ef3072d$export$ade5168a554b7644 = ({ children: children, rowHeight: rowHeight, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a7d8ed6b2ef3072d$var$SimpleTableContainer, {
        rowHeight: rowHeight,
        "data-testid": testId
    }, children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7d8ed6b2ef3072d$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1rjcu2gc _1e0c1txw _2lx21bp4 _1bsb1osq _vchhusvi",
            __cmplp.className
        ])
    });
});
const $a7d8ed6b2ef3072d$var$TruncateContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $a7d8ed6b2ef3072d$var$SimpleTableContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { rowHeight: rowHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_2mmgl8": (0, $lD23V.default)(__cmplp.rowHeight ? (0, $gwIPs.gridSize) * __cmplp.rowHeight : 'auto')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1jzq1qwm _6l9yjp4b _1hvyidpf _r02pidpf",
            __cmplp.className
        ])
    });
});
var $a7d8ed6b2ef3072d$export$2e2bcd8739ae039 = $a7d8ed6b2ef3072d$var$Container;

});


parcelRegister("gnscx", function(module, exports) {

let $bec4ab79e8bff056$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $bec4ab79e8bff056$var$load("ffQaD"),
    $bec4ab79e8bff056$var$load("kvRbA"),
    $bec4ab79e8bff056$var$load("kNFvF"),
    $bec4ab79e8bff056$var$load("iJrOK")
]).then(()=>parcelRequire('1iLiS'));

});


parcelRegister("c1Eoe", function(module, exports) {

$parcel$export(module.exports, "default", () => $03eb7d451898ebfb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $03eb7d451898ebfb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    branchTabLabel: {
        "id": "development.details.main.branch-tab-label",
        "defaultMessage": "Branches"
    },
    pullRequestsTabLabel: {
        "id": "development.details.main.pull-requests-tab-label",
        "defaultMessage": "Pull requests"
    },
    buildTabLabel: {
        "id": "development.details.main.build-tab-label",
        "defaultMessage": "Builds"
    },
    commitTabLabel: {
        "id": "development.details.main.commit-tab-label",
        "defaultMessage": "Commits"
    },
    deploymentsTabLabel: {
        "id": "development.details.main.deployments-tab-label",
        "defaultMessage": "Deployments"
    },
    featureFlagsLabel: {
        "id": "development.details.main.feature-flags-label",
        "defaultMessage": "Feature flags"
    },
    remoteLinksLabel: {
        "id": "development.details.main.remote-links-label",
        "defaultMessage": "Other links"
    }
});

});

parcelRegister("84tTm", function(module, exports) {

$parcel$export(module.exports, "default", () => $210383bd281682fb$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7QSqG = parcelRequire("7QSqG");

var $fphHl = parcelRequire("fphHl");
var $eQ4wW = parcelRequire("eQ4wW");

var $9fuVs = parcelRequire("9fuVs");

var $iUFzA = parcelRequire("iUFzA");

var $az4zD = parcelRequire("az4zD");

var $7NYq5 = parcelRequire("7NYq5");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $iuYCn = parcelRequire("iuYCn");

var $iS7W3 = parcelRequire("iS7W3");
const $210383bd281682fb$export$1615b9091acd4226 = ({ children: children })=>{
    const tabPanelAttributes = (0, $eQ4wW.useTabPanel)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($210383bd281682fb$var$TabPanel, tabPanelAttributes, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, children));
};
class $210383bd281682fb$export$3e8048d3cf2ba3fd extends (0, $5uXOq.Component) {
    componentDidUpdate(prevProps) {
        const { activeTab: prevActiveTab } = prevProps;
        const { activeTab: activeTab } = this.props;
        if (this.bodyRef.current && activeTab !== prevActiveTab) this.bodyRef.current.scrollTop = 0;
    }
    renderTabContent() {
        const { issueId: issueId, issueKey: issueKey, baseUrl: baseUrl, locale: locale, tabs: tabs } = this.props;
        return tabs.map(({ TabContent: TabContent, ...tab })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($210383bd281682fb$export$1615b9091acd4226, {
                key: tab.type
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TabContent, {
                issueId: issueId,
                issueKey: issueKey,
                baseUrl: baseUrl,
                locale: locale
            })));
    }
    renderMetricsElements() {
        if (this.props.isLoading) return [];
        if (this.props.isError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
            eventName: "developmentDetailsDialog failed",
            attributes: {
                errorType: 'serverError'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iUFzA.CancelMetric), {
            metric: (0, $iuYCn.devDetailsTimeToLoad)
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
            eventName: "developmentDetailsDialog rendered"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iUFzA.StopMetric), {
            metric: (0, $iuYCn.devDetailsTimeToLoad)
        }));
    }
    render() {
        const { activeTab: activeTab, tabs: tabs } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            sourceName: "devPanelDetailsDialog",
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iS7W3.RepoPromptForGithubBannerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal // @ts-expect-error - TS2769 - No overload matches this call.
        ), {
            onClose: this.onClose,
            width: "x-large",
            height: "800px",
            testId: "development-details.main.modal-dialog",
            autoFocus: false,
            messageId: "development-details.main.modal-dialog",
            messageType: "transactional"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fphHl.default), {
            id: "dev-details-dialog-tab",
            selected: tabs.findIndex((tab)=>tab.type === activeTab),
            onChange: this.onChangeTab,
            shouldUnmountTabPanelOnChange: true
        }, this.renderHeader(), this.renderTabContent()), this.renderMetricsElements(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
            attributes: {
                activeTab: activeTab
            }
        })))));
    }
    constructor(...args){
        super(...args), this.bodyRef = /*#__PURE__*/ (0, $5uXOq.createRef)() // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.onClose = (event, analyticsEvent)=>{
            const { onCloseDialog: onCloseDialog } = this.props;
            onCloseDialog();
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'closeDevPanelDetailsDialog');
            (0, $iuYCn.devDetailsTimeToLoad).cancel();
        }, this.renderHeader = ()=>{
            const { intl: intl, issueKey: issueKey, Header: Header, tabs: tabs, activeTab: activeTab, onChangeTab: onChangeTab, issueId: issueId } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, {
                intl: intl,
                issueId: issueId,
                issueKey: issueKey,
                tabs: tabs,
                activeTab: activeTab,
                onChangeTab: onChangeTab,
                onClose: this.onClose
            });
        }, this.onChangeTab = (selectedIndex)=>{
            const { activeTab: activeTab, tabs: tabs } = this.props;
            const currentIndex = tabs.findIndex((tab)=>tab.type === activeTab);
            if (currentIndex !== selectedIndex) {
                const { type: type } = tabs[selectedIndex];
                this.props.onChangeTab(type);
            }
        };
    }
}
var $210383bd281682fb$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($210383bd281682fb$export$3e8048d3cf2ba3fd);
const $210383bd281682fb$var$TabPanel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx21bp4 _1695idpf _1pnsidpf _vktqidpf _1byqidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fphHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4810d6c8b7d5c95d$export$2e2bcd8739ae039);
/* tabs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $dWD6q = parcelRequire("dWD6q");
const $4810d6c8b7d5c95d$var$baseStyles = null;
const $4810d6c8b7d5c95d$var$tabsStyles = null;
const $4810d6c8b7d5c95d$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $4810d6c8b7d5c95d$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dWD6q.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        children: tabPanel
    }, index); /**
                                * __Tabs__
                                *
                                * Tabs acts as a container for all Tab components.
                                *
                                * - [Examples](https://atlassian.design/components/tabs/examples)
                                * - [Code](https://atlassian.design/components/tabs/code)
                                * - [Usage](https://atlassian.design/components/tabs/usage)
                                */ 
const $4810d6c8b7d5c95d$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $5uXOq.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $5uXOq.Children).toArray(children) // Don't include any conditional children
    .filter((child)=>Boolean(child)); // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray; // Keep track of visited and add to a set
    const visited = (0, $5uXOq.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $5uXOq.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$4810d6c8b7d5c95d$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $4810d6c8b7d5c95d$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$4810d6c8b7d5c95d$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _p12f1osq _1tkeidpf _i0dl1osq _2lx21bp4 _16jlkb7n",
            "_1c3y1txw _ftfaidpf _18i0kb7n _185bglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dWD6q.TabListContext).Provider, {
                value: {
                    selected: selected,
                    onChange: onChangeAnalytics,
                    tabsId: id
                },
                children: tabList
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                children: tabPanelsWithContext
            })
        ]
    });
};
var $4810d6c8b7d5c95d$export$2e2bcd8739ae039 = $4810d6c8b7d5c95d$var$Tabs;

});
parcelRegister("dWD6q", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $b47499898157cfdc$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $b47499898157cfdc$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $b47499898157cfdc$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5uXOq = parcelRequire("5uXOq");
const $b47499898157cfdc$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b47499898157cfdc$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b47499898157cfdc$export$2054129d247c3102 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});


parcelRegister("eQ4wW", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $4d8616502e4de6b0$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $4d8616502e4de6b0$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $4d8616502e4de6b0$export$fae0121b5afe572d);

var $5uXOq = parcelRequire("5uXOq");

var $dWD6q = parcelRequire("dWD6q");
const $4d8616502e4de6b0$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $5uXOq.useContext)((0, $dWD6q.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $4d8616502e4de6b0$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $5uXOq.useContext)((0, $dWD6q.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $4d8616502e4de6b0$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $5uXOq.useContext)((0, $dWD6q.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});

parcelRegister("iS7W3", function(module, exports) {

$parcel$export(module.exports, "RepoPromptForGithubBannerContainer", () => $a342c5eab8d085a5$export$45dde93000762220);
$parcel$export(module.exports, "useRepoPromptForGitHubBannerStore", () => $a342c5eab8d085a5$export$eb324ac18e7a4169);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $a342c5eab8d085a5$export$d4c72bab9d6cc13a = {};
const $a342c5eab8d085a5$export$45dde93000762220 = (0, $gg7kZ.createContainer)();
const $a342c5eab8d085a5$export$e324594224ef24da = {
    setRepoPromptForGitHubBannerDetails: (repoId, details)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const repoDetail = state[repoId] || {};
            setState({
                ...state,
                [repoId]: {
                    ...repoDetail,
                    ...details
                }
            });
        }
};
const $a342c5eab8d085a5$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    initialState: $a342c5eab8d085a5$export$d4c72bab9d6cc13a,
    containedBy: $a342c5eab8d085a5$export$45dde93000762220,
    actions: $a342c5eab8d085a5$export$e324594224ef24da,
    name: 'repo-prompt-for-github-banner-store'
});
const $a342c5eab8d085a5$export$eb324ac18e7a4169 = (0, $3sQ5x.createHook)($a342c5eab8d085a5$export$390f32400eaf98c9);

});




parcelRegister("4HJKb", function(module, exports) {

$parcel$export(module.exports, "loadDialogBridge", () => $ccf4b85a4aaf3a68$export$7e12f7cd0f50fe5a);
$parcel$export(module.exports, "DevOpsDetailsDialogLoaderContainer", () => $ccf4b85a4aaf3a68$export$5e6e4cfb89bdcb55);
$parcel$export(module.exports, "DevOpsDetailsDialogLoaderSubscriber", () => $ccf4b85a4aaf3a68$export$693f51ab225dff94);
$parcel$export(module.exports, "useDevOpsDetailsDialogLoaderActions", () => $ccf4b85a4aaf3a68$export$506ad06ecf691cd3);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");


var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
var $bKpgX = parcelRequire("bKpgX");

var $62M1I = parcelRequire("62M1I");
const $ccf4b85a4aaf3a68$export$7e12f7cd0f50fe5a = async ()=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $6BZYo.loadBridge)({
        name: (0, $62M1I.DEV_DETAILS_WRM_RESOURCE),
        wrmKeys: [
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-wrm',
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources'
        ]
    });
const $ccf4b85a4aaf3a68$export$e324594224ef24da = {
    resetState: (stateOverrides)=>({ setState: setState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                ...(0, $62M1I.INITIAL_STATE),
                ...stateOverrides
            });
        },
    updateState: (stateUpdates)=>({ getState: getState, setState: setState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                ...getState(),
                ...stateUpdates
            });
        },
    showDevDetailDialog: (itemType, legacyData, targetIssueKey, targetIssueId)=>({ setState: setState, getState: getState })=>{
            if (itemType === (0, $61a2cd6236d50c20$export$3f1e2b276d607490)) // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                legacyDevPanelDetailsDialogShownCounter: // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                getState().legacyDevPanelDetailsDialogShownCounter + 1,
                isDevPanelDetailsDialogShown: false,
                dataTypeSelected: itemType,
                legacyData: legacyData,
                issueKey: targetIssueKey,
                issueId: targetIssueId
            });
            else // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                isDevPanelDetailsDialogShown: true,
                dataTypeSelected: itemType,
                issueKey: targetIssueKey,
                issueId: targetIssueId
            });
        },
    closeDetailDialog: ()=>({ setState: setState, getState: getState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                // @ts-expect-error - TS2322 - Type '""' is not assignable to type 'PanelDataTypes | undefined'.
                dataTypeSelected: '',
                isDevPanelDetailsDialogShown: false,
                issueKey: undefined,
                issueId: undefined
            });
        }
};
const $ccf4b85a4aaf3a68$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'DetailsDialogLoaderRemoteState',
    initialState: (0, $62M1I.INITIAL_STATE),
    actions: $ccf4b85a4aaf3a68$export$e324594224ef24da
});
const $ccf4b85a4aaf3a68$export$5e6e4cfb89bdcb55 = (0, $gg7kZ.createContainer)($ccf4b85a4aaf3a68$export$390f32400eaf98c9);
const $ccf4b85a4aaf3a68$export$693f51ab225dff94 = (0, $51nlc.createSubscriber)($ccf4b85a4aaf3a68$export$390f32400eaf98c9);
const $ccf4b85a4aaf3a68$export$550d4b3c29100112 = (0, $3sQ5x.createHook)($ccf4b85a4aaf3a68$export$390f32400eaf98c9);
function $ccf4b85a4aaf3a68$export$506ad06ecf691cd3(scopeId) {
    return (0, $bKpgX.defaultRegistry).getStore($ccf4b85a4aaf3a68$export$390f32400eaf98c9, scopeId)?.actions;
}

});
parcelRegister("62M1I", function(module, exports) {

$parcel$export(module.exports, "INITIAL_STATE", () => $bf37254db56efc10$export$36d128238e6b60f5);
$parcel$export(module.exports, "DEV_DETAILS_WRM_RESOURCE", () => $bf37254db56efc10$export$43a8ab4f373ff0ee);
const $bf37254db56efc10$export$36d128238e6b60f5 = {
    issueId: '',
    issueKey: undefined,
    locale: 'en_US',
    // @ts-expect-error - TS2322 - Type '""' is not assignable to type 'PanelDataTypes'.
    dataTypeSelected: '',
    legacyData: undefined,
    isDevPanelDetailsDialogShown: false,
    legacyDevPanelDetailsDialogShownCounter: 0
};
const $bf37254db56efc10$export$b5ed55f3ed234f95 = 'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources';
const $bf37254db56efc10$export$43a8ab4f373ff0ee = 'jira-development-status/releasereport/dev-status-dialog-bridge';
const $bf37254db56efc10$export$432f9ff6c01431e3 = 'jira-development-status/util/WRM';

});




//# sourceMappingURL=async-dev-panel-details-loader.a0492644.js.map
